const listOfCitiesWithLatLng = { "aachen": { lat: 50.7756, lng: 6.0836 },
    "aalen": { lat: 48.8333, lng: 10.1 },
    "abensberg": { lat: 48.8, lng: 11.85 },
    "achern": { lat: 48.6333, lng: 8.0667 },
    "achim": { lat: 53.0653, lng: 9.0342 },
    "adelsdorf": { lat: 49.7167, lng: 10.9 },
    "adendorf": { lat: 53.2833, lng: 10.45 },
    "aerzen": { lat: 52.0494, lng: 9.2653 },
    "ahaus": { lat: 52.0667, lng: 7 },
    "ahlen": { lat: 51.7633, lng: 7.8911 },
    "ahrensbok": { lat: 54.0167, lng: 10.5833 },
    "ahrensburg": { lat: 53.6747, lng: 10.2411 },
    "ahrensfelde": { lat: 52.5758, lng: 13.5764 },
    "aich": { lat: 48.6228, lng: 9.2372 },
    "aichach": { lat: 48.45, lng: 11.1333 },
    "aidlingen": { lat: 48.6792, lng: 8.8969 },
    "ainring": { lat: 47.8136, lng: 12.9428 },
    "albstadt": { lat: 48.2119, lng: 9.0239 },
    "aldenhoven": { lat: 50.8958, lng: 6.2831 },
    "alfeld": { lat: 51.9886, lng: 9.8269 },
    "alfter": { lat: 50.7356, lng: 7.0092 },
    "alpen": { lat: 51.575, lng: 6.5125 },
    "alsbachhahnlein": { lat: 49.7333, lng: 8.6 },
    "alsdorf": { lat: 50.8833, lng: 6.1667 },
    "alsfeld": { lat: 50.7511, lng: 9.2711 },
    "altdorf": { lat: 48.5667, lng: 12.1167 },
    "altena": { lat: 51.3, lng: 7.6667 },
    "altenbeken": { lat: 51.7667, lng: 8.9333 },
    "altenberge": { lat: 52.0458, lng: 7.4653 },
    "altenburg": { lat: 50.985, lng: 12.4333 },
    "altenholz": { lat: 54.4, lng: 10.1333 },
    "altenstadt": { lat: 50.2856, lng: 8.945 },
    "altensteig": { lat: 48.5864, lng: 8.6047 },
    "altlandsberg": { lat: 52.5667, lng: 13.7331 },
    "altotting": { lat: 48.2267, lng: 12.6783 },
    "altusried": { lat: 47.8, lng: 10.2167 },
    "alzenauinunterfranken": { lat: 50.0667, lng: 9.0667 },
    "alzey": { lat: 49.7458, lng: 8.1153 },
    "amberg": { lat: 49.4444, lng: 11.8483 },
    "andernach": { lat: 50.4397, lng: 7.4017 },
    "angermunde": { lat: 53.0333, lng: 14 },
    "anklam": { lat: 53.85, lng: 13.6833 },
    "annabergbuchholz": { lat: 50.58, lng: 13.0022 },
    "anrochte": { lat: 51.5667, lng: 8.3333 },
    "ansbach": { lat: 49.3, lng: 10.5833 },
    "apen": { lat: 53.2214, lng: 7.8097 },
    "apolda": { lat: 51.0167, lng: 11.5167 },
    "appenweier": { lat: 48.5397, lng: 7.98 },
    "arnsberg": { lat: 51.3833, lng: 8.0833 },
    "arnstadt": { lat: 50.8342, lng: 10.9464 },
    "aschaffenburg": { lat: 49.9667, lng: 9.15 },
    "ascheberg": { lat: 51.7889, lng: 7.62 },
    "aschersleben": { lat: 51.75, lng: 11.4667 },
    "aschheim": { lat: 48.1733, lng: 11.7178 },
    "asperg": { lat: 48.9, lng: 9.1333 },
    "asslar": { lat: 50.5833, lng: 8.4667 },
    "attendorn": { lat: 51.1289, lng: 7.9022 },
    "aue": { lat: 50.5881, lng: 12.7006 },
    "auerbach": { lat: 49.6833, lng: 11.6167 },
    "augsburg": { lat: 48.3689, lng: 10.8978 },
    "augustdorf": { lat: 51.9, lng: 8.7333 },
    "aulendorf": { lat: 47.9542, lng: 9.6389 },
    "aurich": { lat: 53.4714, lng: 7.4836 },
    "babenhausen": { lat: 49.9667, lng: 8.95 },
    "backnang": { lat: 48.9464, lng: 9.4306 },
    "badabbach": { lat: 48.9333, lng: 12.05 },
    "badaibling": { lat: 47.8639, lng: 12.01 },
    "badbentheim": { lat: 52.3031, lng: 7.1597 },
    "badbergzabern": { lat: 49.1028, lng: 7.9991 },
    "badberleburg": { lat: 51.0497, lng: 8.4 },
    "badbevensen": { lat: 53.0792, lng: 10.5833 },
    "badbramstedt": { lat: 53.9186, lng: 9.8844 },
    "badbreisig": { lat: 50.5092, lng: 7.2964 },
    "badcamberg": { lat: 50.3, lng: 8.2667 },
    "baddriburg": { lat: 51.7333, lng: 9.0167 },
    "baddurkheim": { lat: 49.4594, lng: 8.1681 },
    "baddurrenberg": { lat: 51.2833, lng: 12.0667 },
    "baddurrheim": { lat: 48.0167, lng: 8.5333 },
    "badems": { lat: 50.3381, lng: 7.7106 },
    "badessen": { lat: 52.3214, lng: 8.34 },
    "badfallingbostel": { lat: 52.8675, lng: 9.6967 },
    "badfeilnbach": { lat: 47.7833, lng: 12.0167 },
    "badfrankenhausen": { lat: 51.3558, lng: 11.1011 },
    "badfreienwalde": { lat: 52.7856, lng: 14.0325 },
    "badgandersheim": { lat: 51.8719, lng: 10.0253 },
    "badharzburg": { lat: 51.8811, lng: 10.5622 },
    "badhersfeld": { lat: 50.8683, lng: 9.7075 },
    "badhomburg": { lat: 50.2167, lng: 8.6 },
    "badhonnefamrhein": { lat: 50.645, lng: 7.2269 },
    "badiburg": { lat: 52.1592, lng: 8.0472 },
    "badkissingen": { lat: 50.2, lng: 10.0667 },
    "badkonig": { lat: 49.75, lng: 9.0167 },
    "badkreuznach": { lat: 49.85, lng: 7.8667 },
    "badkrozingen": { lat: 47.9167, lng: 7.7 },
    "badlaasphe": { lat: 50.9303, lng: 8.4167 },
    "badlaer": { lat: 52.1031, lng: 8.0892 },
    "badlangensalza": { lat: 51.1081, lng: 10.6467 },
    "badlauchstadt": { lat: 51.3667, lng: 11.8333 },
    "badlauterberg": { lat: 51.6317, lng: 10.4706 },
    "badliebenwerda": { lat: 51.5167, lng: 13.4 },
    "badliebenzell": { lat: 48.7742, lng: 8.7314 },
    "badlippspringe": { lat: 51.7833, lng: 8.8167 },
    "badmergentheim": { lat: 49.5, lng: 9.7667 },
    "badmunderamdeister": { lat: 52.1992, lng: 9.4653 },
    "badmunstereifel": { lat: 50.5531, lng: 6.7661 },
    "badnauheim": { lat: 50.3667, lng: 8.75 },
    "badnenndorf": { lat: 52.3369, lng: 9.3786 },
    "badneuenahrahrweiler": { lat: 50.5447, lng: 7.1133 },
    "badneustadt": { lat: 50.3219, lng: 10.2161 },
    "badoeynhausen": { lat: 52.2, lng: 8.8 },
    "badoldesloe": { lat: 53.8117, lng: 10.3742 },
    "badorb": { lat: 50.2167, lng: 9.35 },
    "badpyrmont": { lat: 51.9867, lng: 9.2636 },
    "badrappenau": { lat: 49.2333, lng: 9.1 },
    "badreichenhall": { lat: 47.7247, lng: 12.8769 },
    "badrothenfelde": { lat: 52.1117, lng: 8.1606 },
    "badsackingen": { lat: 47.55, lng: 7.95 },
    "badsalzdetfurth": { lat: 52.0653, lng: 10.0092 },
    "badsalzuflen": { lat: 52.0833, lng: 8.7467 },
    "badsalzungen": { lat: 50.8117, lng: 10.2333 },
    "badsassendorf": { lat: 51.5831, lng: 8.1667 },
    "badschussenried": { lat: 48.0067, lng: 9.6586 },
    "badschwalbach": { lat: 50.1333, lng: 8.0667 },
    "badschwartau": { lat: 53.9194, lng: 10.6975 },
    "badsegeberg": { lat: 53.9167, lng: 10.3167 },
    "badsodenamtaunus": { lat: 50.1333, lng: 8.5 },
    "badsodensalmunster": { lat: 50.2667, lng: 9.3667 },
    "badtolz": { lat: 47.7603, lng: 11.5567 },
    "badurach": { lat: 48.4931, lng: 9.3986 },
    "badvilbel": { lat: 50.1781, lng: 8.7361 },
    "badwaldsee": { lat: 47.9211, lng: 9.7519 },
    "badwildbad": { lat: 48.7503, lng: 8.5506 },
    "badwildungen": { lat: 51.1167, lng: 9.1167 },
    "badwindsheim": { lat: 49.5, lng: 10.4167 },
    "badworishofen": { lat: 48.0058, lng: 10.5969 },
    "badwurzach": { lat: 47.9094, lng: 9.8994 },
    "badzwischenahn": { lat: 53.1836, lng: 8.0097 },
    "badenbaden": { lat: 48.7628, lng: 8.2408 },
    "baesweiler": { lat: 50.9, lng: 6.1833 },
    "baiersbronn": { lat: 48.5058, lng: 8.3711 },
    "balingen": { lat: 48.2731, lng: 8.8506 },
    "ballenstedt": { lat: 51.72, lng: 11.2375 },
    "balve": { lat: 51.3333, lng: 7.8667 },
    "bamberg": { lat: 49.8914, lng: 10.8869 },
    "bannewitz": { lat: 50.9931, lng: 13.7167 },
    "bargteheide": { lat: 53.7167, lng: 10.2667 },
    "barleben": { lat: 52.2, lng: 11.6333 },
    "barmstedt": { lat: 53.7833, lng: 9.7667 },
    "barntrup": { lat: 51.9831, lng: 9.1167 },
    "barsbuttel": { lat: 53.5689, lng: 10.1711 },
    "barsinghausen": { lat: 52.3, lng: 9.4811 },
    "barssel": { lat: 53.1703, lng: 7.7467 },
    "barth": { lat: 54.3667, lng: 12.7167 },
    "bassum": { lat: 52.8494, lng: 8.7267 },
    "baunatal": { lat: 51.2589, lng: 9.4183 },
    "bautzen": { lat: 51.1814, lng: 14.4242 },
    "bayreuth": { lat: 49.9481, lng: 11.5783 },
    "bebra": { lat: 50.9711, lng: 9.7903 },
    "beckingen": { lat: 49.3928, lng: 6.7008 },
    "beckum": { lat: 51.755, lng: 8.0403 },
    "bedburg": { lat: 51.7667, lng: 6.1833 },
    "beelitz": { lat: 52.2333, lng: 12.9667 },
    "beilngries": { lat: 49.0333, lng: 11.4667 },
    "bellheim": { lat: 49.1981, lng: 8.2792 },
    "belm": { lat: 52.3, lng: 8.1333 },
    "belzig": { lat: 52.1422, lng: 12.5956 },
    "bendorf": { lat: 50.4297, lng: 7.5703 },
    "bensheim": { lat: 49.6667, lng: 8.6167 },
    "berching": { lat: 49.1, lng: 11.4333 },
    "bergen": { lat: 54.4167, lng: 13.4333 },
    "bergheim": { lat: 50.9667, lng: 6.65 },
    "bergischgladbach": { lat: 50.9918, lng: 7.1303 },
    "bergkamen": { lat: 51.6167, lng: 7.6333 },
    "bergneustadt": { lat: 51.0333, lng: 7.65 },
    "berlin": { lat: 52.52, lng: 13.405 },
    "bernburg": { lat: 51.8, lng: 11.7333 },
    "bersenbruck": { lat: 52.5333, lng: 7.9167 },
    "besigheim": { lat: 48.9983, lng: 9.1417 },
    "bestensee": { lat: 52.25, lng: 13.65 },
    "bestwig": { lat: 51.3667, lng: 8.4 },
    "betzdorf": { lat: 50.7856, lng: 7.8728 },
    "beutelsbach": { lat: 48.8, lng: 9.3833 },
    "beverstedt": { lat: 53.4333, lng: 8.8167 },
    "beverungen": { lat: 51.6628, lng: 9.3725 },
    "bexbach": { lat: 49.3494, lng: 7.2594 },
    "biberach": { lat: 48.1, lng: 9.7833 },
    "biblis": { lat: 49.7, lng: 8.4667 },
    "bieber": { lat: 50.6, lng: 8.5833 },
    "biedenkopf": { lat: 50.9128, lng: 8.5322 },
    "biederitz": { lat: 52.1608, lng: 11.7178 },
    "bielefeld": { lat: 52.0211, lng: 8.5347 },
    "bietigheimbissingen": { lat: 48.9667, lng: 9.1333 },
    "billerbeck": { lat: 51.9792, lng: 7.295 },
    "bingenamrhein": { lat: 49.9667, lng: 7.9 },
    "birkenau": { lat: 49.5625, lng: 8.7069 },
    "birkenfeld": { lat: 48.8697, lng: 8.6361 },
    "bischofsheim": { lat: 49.9833, lng: 8.35 },
    "bischofswerda": { lat: 51.1275, lng: 14.1797 },
    "bisingen": { lat: 48.3119, lng: 8.9178 },
    "bissendorf": { lat: 52.2333, lng: 8.1667 },
    "bitburg": { lat: 49.9667, lng: 6.5333 },
    "bitterfeld": { lat: 51.6167, lng: 12.3167 },
    "blankenburg": { lat: 51.7953, lng: 10.9622 },
    "blankenfelde": { lat: 52.35, lng: 13.4 },
    "blaubeuren": { lat: 48.4119, lng: 9.785 },
    "bleicherode": { lat: 51.4167, lng: 10.5667 },
    "blieskastel": { lat: 49.2333, lng: 7.25 },
    "blomberg": { lat: 51.9333, lng: 9.0833 },
    "blumberg": { lat: 47.8392, lng: 8.5342 },
    "bobenheimroxheim": { lat: 49.5833, lng: 8.35 },
    "bobingen": { lat: 48.2667, lng: 10.8167 },
    "boblingen": { lat: 48.6856, lng: 9.0153 },
    "bocholt": { lat: 51.8333, lng: 6.6167 },
    "bochum": { lat: 51.4819, lng: 7.2158 },
    "bockenem": { lat: 52.0117, lng: 10.1319 },
    "bockhorn": { lat: 53.4, lng: 8.0167 },
    "bockum": { lat: 51.3333, lng: 6.5667 },
    "bogen": { lat: 48.9167, lng: 12.6833 },
    "bohliggelheim": { lat: 49.3833, lng: 8.3 },
    "bohmte": { lat: 52.3667, lng: 8.3167 },
    "boizenburg": { lat: 53.3667, lng: 10.7167 },
    "bonen": { lat: 51.5986, lng: 7.7592 },
    "bonn": { lat: 50.7353, lng: 7.1022 },
    "bopfingen": { lat: 48.8569, lng: 10.3522 },
    "boppard": { lat: 50.2314, lng: 7.5908 },
    "borgentreich": { lat: 51.5667, lng: 9.25 },
    "borgholzhausen": { lat: 52.1, lng: 8.3 },
    "borken": { lat: 51.0458, lng: 9.2672 },
    "borna": { lat: 51.1167, lng: 12.5 },
    "bornheim": { lat: 50.7592, lng: 7.005 },
    "bosel": { lat: 53.0058, lng: 7.9542 },
    "bottrop": { lat: 51.5247, lng: 6.9228 },
    "bovenden": { lat: 51.5897, lng: 9.9222 },
    "brackenheim": { lat: 49.0833, lng: 9.0667 },
    "brake": { lat: 53.3333, lng: 8.4833 },
    "brakel": { lat: 51.7167, lng: 9.1833 },
    "bramsche": { lat: 52.4, lng: 7.9833 },
    "brand": { lat: 50.7489, lng: 6.165 },
    "branderbisdorf": { lat: 50.8689, lng: 13.3219 },
    "brandenburg": { lat: 52.4167, lng: 12.5333 },
    "brandis": { lat: 51.3347, lng: 12.6089 },
    "braunfels": { lat: 50.5167, lng: 8.3833 },
    "braunsbedra": { lat: 51.2833, lng: 11.9 },
    "braunschweig": { lat: 52.2667, lng: 10.5167 },
    "breckerfeld": { lat: 51.2667, lng: 7.4667 },
    "breisachamrhein": { lat: 48.0333, lng: 7.5833 },
    "bremen": { lat: 53.0758, lng: 8.8072 },
    "bremerhaven": { lat: 53.55, lng: 8.5833 },
    "bremervorde": { lat: 53.4833, lng: 9.1333 },
    "bretten": { lat: 49.0364, lng: 8.7061 },
    "bretzfeld": { lat: 49.1833, lng: 9.4333 },
    "brieselang": { lat: 52.5833, lng: 13 },
    "brilon": { lat: 51.3956, lng: 8.5678 },
    "bruchhausenvilsen": { lat: 52.8333, lng: 9 },
    "bruchkobel": { lat: 50.1833, lng: 8.9167 },
    "bruchsal": { lat: 49.1333, lng: 8.6 },
    "bruckmuhl": { lat: 47.8833, lng: 11.9167 },
    "bruggen": { lat: 51.2417, lng: 6.1822 },
    "bruhl": { lat: 49.4, lng: 8.5333 },
    "brunsbuttel": { lat: 53.8964, lng: 9.1386 },
    "bucheninodenwald": { lat: 49.5217, lng: 9.3233 },
    "buchholzindernordheide": { lat: 53.3167, lng: 9.8667 },
    "buchloe": { lat: 48.0375, lng: 10.725 },
    "buckeburg": { lat: 52.2608, lng: 9.0492 },
    "budelsdorf": { lat: 54.3167, lng: 9.6833 },
    "budenheim": { lat: 50.0167, lng: 8.1667 },
    "budingen": { lat: 50.2908, lng: 9.1125 },
    "buhl": { lat: 48.6953, lng: 8.135 },
    "bunde": { lat: 52.2, lng: 8.6 },
    "burbach": { lat: 50.7444, lng: 8.0861 },
    "burg": { lat: 52.2725, lng: 11.855 },
    "burgau": { lat: 48.4322, lng: 10.4069 },
    "burgdorf": { lat: 52.45, lng: 10.0083 },
    "burghausen": { lat: 48.1667, lng: 12.8333 },
    "burgkirchenanderalz": { lat: 48.1667, lng: 12.7167 },
    "burglengenfeld": { lat: 49.2, lng: 12.0333 },
    "burgstadt": { lat: 50.9167, lng: 12.8167 },
    "burgthann": { lat: 49.35, lng: 11.3 },
    "burladingen": { lat: 48.2903, lng: 9.1094 },
    "burscheid": { lat: 51.1, lng: 7.1167 },
    "burstadt": { lat: 49.6333, lng: 8.45 },
    "buttelborn": { lat: 49.9, lng: 8.5167 },
    "butzbach": { lat: 50.4367, lng: 8.6622 },
    "buxtehude": { lat: 53.4769, lng: 9.7011 },
    "cadolzburg": { lat: 49.45, lng: 10.8667 },
    "calw": { lat: 48.7167, lng: 8.7333 },
    "castroprauxel": { lat: 51.55, lng: 7.3167 },
    "celle": { lat: 52.6256, lng: 10.0825 },
    "cham": { lat: 49.2167, lng: 12.65 },
    "chemnitz": { lat: 50.8333, lng: 12.9167 },
    "clausthalzellerfeld": { lat: 51.805, lng: 10.3356 },
    "cloppenburg": { lat: 52.85, lng: 8.05 },
    "coburg": { lat: 50.2667, lng: 10.9667 },
    "coesfeld": { lat: 51.95, lng: 7.1667 },
    "cologne": { lat: 50.9364, lng: 6.9528 },
    "coswig": { lat: 51.1333, lng: 13.5833 },
    "cottbus": { lat: 51.7606, lng: 14.3342 },
    "crailsheim": { lat: 49.1347, lng: 10.0706 },
    "cremlingen": { lat: 52.2489, lng: 10.6542 },
    "crimmitschau": { lat: 50.8181, lng: 12.3875 },
    "cuxhaven": { lat: 53.8611, lng: 8.6944 },
    "dachau": { lat: 48.2603, lng: 11.4342 },
    "dallgowdoberitz": { lat: 52.5331, lng: 13.05 },
    "damme": { lat: 52.5208, lng: 8.1986 },
    "darmstadt": { lat: 49.8722, lng: 8.6528 },
    "dassel": { lat: 51.8033, lng: 9.6903 },
    "datteln": { lat: 51.6539, lng: 7.3417 },
    "dautphe": { lat: 50.8333, lng: 8.55 },
    "deggendorf": { lat: 48.8333, lng: 12.9667 },
    "delbruck": { lat: 51.7667, lng: 8.5667 },
    "delitzsch": { lat: 51.5264, lng: 12.3425 },
    "delmenhorst": { lat: 53.0506, lng: 8.6317 },
    "demmin": { lat: 53.905, lng: 13.0439 },
    "denkendorf": { lat: 48.6958, lng: 9.3175 },
    "denzlingen": { lat: 48.0683, lng: 7.8825 },
    "detmold": { lat: 51.9378, lng: 8.8833 },
    "dettingenandererms": { lat: 48.53, lng: 9.3472 },
    "dieburg": { lat: 49.9, lng: 8.85 },
    "diedorf": { lat: 48.35, lng: 10.7667 },
    "dielheim": { lat: 49.2825, lng: 8.7347 },
    "diepholz": { lat: 52.6072, lng: 8.3711 },
    "diessenamammersee": { lat: 47.95, lng: 11.1 },
    "dietmannsried": { lat: 47.8167, lng: 10.2833 },
    "dietzenbach": { lat: 50.0167, lng: 8.7833 },
    "diez": { lat: 50.3708, lng: 8.0158 },
    "dillenburg": { lat: 50.7333, lng: 8.2833 },
    "dillingen": { lat: 48.5667, lng: 10.4667 },
    "dingelstadt": { lat: 51.3156, lng: 10.3194 },
    "dingolfing": { lat: 48.6333, lng: 12.5 },
    "dinkelsbuhl": { lat: 49.0708, lng: 10.3194 },
    "dinklage": { lat: 52.6667, lng: 8.1333 },
    "dinslaken": { lat: 51.5667, lng: 6.7333 },
    "dippoldiswalde": { lat: 50.8933, lng: 13.6667 },
    "ditzingen": { lat: 48.8264, lng: 9.0667 },
    "dobeln": { lat: 51.1194, lng: 13.1128 },
    "doberlugkirchhain": { lat: 51.6167, lng: 13.5667 },
    "donaueschingen": { lat: 47.9531, lng: 8.5033 },
    "donauworth": { lat: 48.7, lng: 10.8 },
    "donzdorf": { lat: 48.6833, lng: 9.8167 },
    "dorfen": { lat: 48.2667, lng: 12.15 },
    "dormagen": { lat: 51.1, lng: 6.8167 },
    "dornstadt": { lat: 48.4692, lng: 9.9417 },
    "dorsten": { lat: 51.66, lng: 6.9642 },
    "dortmund": { lat: 51.5139, lng: 7.4653 },
    "dorverden": { lat: 52.85, lng: 9.2333 },
    "dossenheim": { lat: 49.45, lng: 8.6667 },
    "dreieich": { lat: 50, lng: 8.7 },
    "drensteinfurt": { lat: 51.7944, lng: 7.7392 },
    "dresden": { lat: 51.05, lng: 13.74 },
    "drochtersen": { lat: 53.7, lng: 9.3833 },
    "drolshagen": { lat: 51.0333, lng: 7.7667 },
    "duderstadt": { lat: 51.5125, lng: 10.2597 },
    "duisburg": { lat: 51.4347, lng: 6.7625 },
    "dulken": { lat: 51.2522, lng: 6.3353 },
    "dulmen": { lat: 51.8308, lng: 7.2783 },
    "duren": { lat: 50.8, lng: 6.4833 },
    "durmersheim": { lat: 48.9383, lng: 8.2769 },
    "dusseldorf": { lat: 51.2256, lng: 6.7767 },
    "eberbach": { lat: 49.4667, lng: 8.9833 },
    "ebersbachanderfils": { lat: 48.7147, lng: 9.5236 },
    "ebersberg": { lat: 48.0833, lng: 11.9667 },
    "eberswalde": { lat: 52.8333, lng: 13.8333 },
    "eching": { lat: 48.3, lng: 11.6167 },
    "edemissen": { lat: 52.3833, lng: 10.2667 },
    "edewecht": { lat: 53.1258, lng: 7.9825 },
    "edingenneckarhausen": { lat: 49.2833, lng: 8.6167 },
    "efringenkirchen": { lat: 47.6556, lng: 7.5658 },
    "egelsbach": { lat: 49.9667, lng: 8.6667 },
    "eggenfelden": { lat: 48.4039, lng: 12.7642 },
    "eggensteinleopoldshafen": { lat: 49.0778, lng: 8.3925 },
    "ehingenanderdonau": { lat: 48.2833, lng: 9.7236 },
    "ehningen": { lat: 48.6589, lng: 8.9403 },
    "ehringshausen": { lat: 50.6, lng: 8.3833 },
    "eichenau": { lat: 48.1667, lng: 11.3167 },
    "eichenzell": { lat: 50.4833, lng: 9.7 },
    "eichstatt": { lat: 48.8919, lng: 11.1839 },
    "eilenburg": { lat: 51.4608, lng: 12.6358 },
    "eilendorf": { lat: 50.7794, lng: 6.1625 },
    "einbeck": { lat: 51.8167, lng: 9.8667 },
    "eisenach": { lat: 50.9761, lng: 10.3206 },
    "eisenberg": { lat: 49.5614, lng: 8.0725 },
    "eisenhuttenstadt": { lat: 52.145, lng: 14.6728 },
    "eislingen": { lat: 48.6933, lng: 9.7067 },
    "eitorf": { lat: 50.7697, lng: 7.4517 },
    "ellwangen": { lat: 48.9611, lng: 10.1306 },
    "elmshorn": { lat: 53.7519, lng: 9.6511 },
    "elsdorf": { lat: 50.9333, lng: 6.5667 },
    "elsen": { lat: 51.7333, lng: 8.6833 },
    "elsenfeld": { lat: 49.85, lng: 9.1667 },
    "elsfleth": { lat: 53.2333, lng: 8.4667 },
    "elze": { lat: 52.1167, lng: 9.7333 },
    "emden": { lat: 53.3669, lng: 7.2061 },
    "emmendingen": { lat: 48.1214, lng: 7.8492 },
    "emsburen": { lat: 52.3925, lng: 7.2914 },
    "emsdetten": { lat: 52.1728, lng: 7.5344 },
    "emstek": { lat: 52.8167, lng: 8.15 },
    "engelskirchen": { lat: 50.9833, lng: 7.4167 },
    "engen": { lat: 47.8528, lng: 8.7714 },
    "enger": { lat: 52.1333, lng: 8.5667 },
    "eningenunterachalm": { lat: 48.4831, lng: 9.2522 },
    "enkesen": { lat: 51.4667, lng: 7.9667 },
    "ennepetal": { lat: 51.2833, lng: 7.3333 },
    "ennigerloh": { lat: 51.8367, lng: 8.0256 },
    "epe": { lat: 52.1833, lng: 7.0333 },
    "eppelborn": { lat: 49.3833, lng: 6.9667 },
    "eppelheim": { lat: 49.4, lng: 8.6333 },
    "eppingen": { lat: 49.1333, lng: 8.9167 },
    "eppstein": { lat: 50.1333, lng: 8.4 },
    "erbach": { lat: 48.3281, lng: 9.8878 },
    "erding": { lat: 48.2833, lng: 11.9 },
    "erftstadt": { lat: 50.8167, lng: 6.7667 },
    "erfurt": { lat: 50.9781, lng: 11.0289 },
    "ergolding": { lat: 48.5833, lng: 12.1667 },
    "ergoldsbach": { lat: 48.6833, lng: 12.2 },
    "erkelenz": { lat: 51.0833, lng: 6.3167 },
    "erkner": { lat: 52.4167, lng: 13.75 },
    "erkrath": { lat: 51.2239, lng: 6.9147 },
    "erlangen": { lat: 49.5833, lng: 11.0167 },
    "erlenbachammain": { lat: 49.8039, lng: 9.1639 },
    "erlensee": { lat: 50.1333, lng: 8.9333 },
    "erwitte": { lat: 51.6167, lng: 8.35 },
    "eschborn": { lat: 50.1436, lng: 8.57 },
    "eschwege": { lat: 51.1881, lng: 10.0528 },
    "eschweiler": { lat: 50.8167, lng: 6.2833 },
    "eslohe": { lat: 51.25, lng: 8.1667 },
    "espelkamp": { lat: 52.3772, lng: 8.6328 },
    "essen": { lat: 51.4508, lng: 7.0131 },
    "essenbach": { lat: 48.6167, lng: 12.2167 },
    "esslingen": { lat: 48.7333, lng: 9.3167 },
    "ettenheim": { lat: 48.2556, lng: 7.8119 },
    "ettlingen": { lat: 48.9333, lng: 8.4 },
    "euskirchen": { lat: 50.6597, lng: 6.7917 },
    "eutin": { lat: 54.1378, lng: 10.6181 },
    "everswinkel": { lat: 51.925, lng: 7.8478 },
    "falkensee": { lat: 52.5583, lng: 13.0917 },
    "fallersleben": { lat: 52.4189, lng: 10.7169 },
    "fehmarnsund": { lat: 54.4454, lng: 11.1702 },
    "fehrbellin": { lat: 52.7997, lng: 12.7667 },
    "feldkirchenwesterham": { lat: 47.9, lng: 11.85 },
    "fellbach": { lat: 48.8086, lng: 9.2758 },
    "felsberg": { lat: 51.1333, lng: 9.4167 },
    "feucht": { lat: 49.3757, lng: 11.213 },
    "feuchtwangen": { lat: 49.1667, lng: 10.3167 },
    "filderstadt": { lat: 48.6803, lng: 9.2183 },
    "finnentrop": { lat: 51.1667, lng: 7.9667 },
    "finsterwalde": { lat: 51.6282, lng: 13.7102 },
    "flensburg": { lat: 54.7819, lng: 9.4367 },
    "flieden": { lat: 50.4167, lng: 9.5667 },
    "floha": { lat: 50.8558, lng: 13.0714 },
    "florsheim": { lat: 50.0167, lng: 8.4333 },
    "florstadt": { lat: 50.3158, lng: 8.8631 },
    "forchheim": { lat: 49.7197, lng: 11.0581 },
    "forstlausitz": { lat: 51.7333, lng: 14.6333 },
    "frankenberg": { lat: 50.9108, lng: 13.0378 },
    "frankenthal": { lat: 49.5333, lng: 8.35 },
    "frankfurtoder": { lat: 52.3419, lng: 14.5517 },
    "frankfurt": { lat: 50.1106, lng: 8.6822 },
    "frechen": { lat: 50.9167, lng: 6.8167 },
    "freibergamneckar": { lat: 48.9333, lng: 9.2 },
    "freiberg": { lat: 50.9119, lng: 13.3428 },
    "freiburgimbreisgau": { lat: 47.995, lng: 7.85 },
    "freilassing": { lat: 47.8333, lng: 12.9667 },
    "freising": { lat: 48.4028, lng: 11.7489 },
    "freital": { lat: 51.0167, lng: 13.65 },
    "freudenberg": { lat: 50.8997, lng: 7.8667 },
    "freudenstadt": { lat: 48.4633, lng: 8.4111 },
    "freystadt": { lat: 49.2, lng: 11.3167 },
    "frickenhausen": { lat: 48.5928, lng: 9.3611 },
    "friedberg": { lat: 48.35, lng: 10.9833 },
    "friedeburg": { lat: 53.45, lng: 7.8333 },
    "friedland": { lat: 51.4217, lng: 9.9144 },
    "friedrichsdorf": { lat: 50.2556, lng: 8.6397 },
    "friedrichshafen": { lat: 47.65, lng: 9.4833 },
    "friedrichsthal": { lat: 49.3256, lng: 7.0961 },
    "friesenheim": { lat: 48.3731, lng: 7.8833 },
    "friesoythe": { lat: 53.0206, lng: 7.8586 },
    "fritzlar": { lat: 51.1333, lng: 9.2833 },
    "frohburg": { lat: 51.0561, lng: 12.555 },
    "frondenberg": { lat: 51.4719, lng: 7.7658 },
    "fulda": { lat: 50.5508, lng: 9.6753 },
    "fuldabruck": { lat: 51.4, lng: 9.4667 },
    "fuldatal": { lat: 51.3833, lng: 9.55 },
    "furstenau": { lat: 52.5167, lng: 7.6667 },
    "furstenfeldbruck": { lat: 48.1778, lng: 11.2556 },
    "furstenwalde": { lat: 52.3667, lng: 14.0667 },
    "furstenzell": { lat: 48.5333, lng: 13.3167 },
    "furthimwald": { lat: 49.3097, lng: 12.84 },
    "furth": { lat: 49.4667, lng: 11 },
    "furtwangenimschwarzwald": { lat: 48.0503, lng: 8.2092 },
    "fussen": { lat: 47.5667, lng: 10.7 },
    "gaggenau": { lat: 48.8039, lng: 8.3194 },
    "gaildorf": { lat: 49, lng: 9.7667 },
    "gaimersheim": { lat: 48.8167, lng: 11.3667 },
    "ganderkesee": { lat: 53.0358, lng: 8.5483 },
    "gangelt": { lat: 50.9831, lng: 6 },
    "garbsen": { lat: 52.4183, lng: 9.5981 },
    "garchinganderalz": { lat: 48.1167, lng: 12.5833 },
    "garchingbeimunchen": { lat: 48.25, lng: 11.65 },
    "gardelegen": { lat: 52.5264, lng: 11.3925 },
    "garmischpartenkirchen": { lat: 47.5, lng: 11.0833 },
    "garrel": { lat: 52.9581, lng: 8.0253 },
    "gartringen": { lat: 48.6408, lng: 8.9006 },
    "gauting": { lat: 48.0678, lng: 11.3739 },
    "geeste": { lat: 52.6, lng: 7.2667 },
    "geesthacht": { lat: 53.4375, lng: 10.3675 },
    "gehrden": { lat: 52.3117, lng: 9.6003 },
    "geilenkirchen": { lat: 50.9653, lng: 6.1194 },
    "geisenfeld": { lat: 48.6667, lng: 11.6 },
    "geisenheim": { lat: 49.9844, lng: 7.9672 },
    "geislingenandersteige": { lat: 48.6244, lng: 9.8306 },
    "geldern": { lat: 51.5197, lng: 6.3325 },
    "gelnhausen": { lat: 50.2, lng: 9.1667 },
    "gelsenkirchen": { lat: 51.5167, lng: 7.1 },
    "gengenbach": { lat: 48.4, lng: 8.0167 },
    "genthin": { lat: 52.4, lng: 12.1667 },
    "georgsmarienhutte": { lat: 52.2, lng: 8.0667 },
    "gera": { lat: 50.8806, lng: 12.0833 },
    "geretsried": { lat: 47.8667, lng: 11.4667 },
    "gerlingen": { lat: 48.8, lng: 9.0653 },
    "germering": { lat: 48.1333, lng: 11.3667 },
    "germersheim": { lat: 49.2167, lng: 8.3667 },
    "gernsbach": { lat: 48.7633, lng: 8.3342 },
    "gernsheim": { lat: 49.75, lng: 8.4833 },
    "gerstetten": { lat: 48.6225, lng: 10.0206 },
    "gersthofen": { lat: 48.4167, lng: 10.8667 },
    "gerstungen": { lat: 50.9625, lng: 10.0597 },
    "gescher": { lat: 51.9569, lng: 7.0056 },
    "geseke": { lat: 51.65, lng: 8.5167 },
    "gevelsberg": { lat: 51.3167, lng: 7.3333 },
    "giengenanderbrenz": { lat: 48.6217, lng: 10.245 },
    "giesen": { lat: 52.2, lng: 9.8833 },
    "giessen": { lat: 50.5833, lng: 8.6667 },
    "gifhorn": { lat: 52.4886, lng: 10.5464 },
    "gilching": { lat: 48.1167, lng: 11.3 },
    "ginsheimgustavsburg": { lat: 49.9833, lng: 8.3333 },
    "gladbeck": { lat: 51.5667, lng: 6.9667 },
    "gladenbach": { lat: 50.7681, lng: 8.5828 },
    "glauchau": { lat: 50.8233, lng: 12.5444 },
    "glinde": { lat: 53.5406, lng: 10.2111 },
    "gluckstadt": { lat: 53.7917, lng: 9.4219 },
    "gnarrenburg": { lat: 53.3864, lng: 9.005 },
    "goch": { lat: 51.6839, lng: 6.1619 },
    "goldbach": { lat: 49.9889, lng: 9.1864 },
    "goldenstedt": { lat: 52.7833, lng: 8.4167 },
    "gomaringen": { lat: 48.452, lng: 9.1 },
    "gommern": { lat: 52.0667, lng: 11.8333 },
    "goppingen": { lat: 48.7025, lng: 9.6528 },
    "gorlitz": { lat: 51.1528, lng: 14.9872 },
    "goslar": { lat: 51.9072, lng: 10.43 },
    "gotha": { lat: 50.9492, lng: 10.705 },
    "gottingen": { lat: 51.5339, lng: 9.9356 },
    "gottmadingen": { lat: 47.7356, lng: 8.7767 },
    "grabenneudorf": { lat: 49.1592, lng: 8.4894 },
    "grafelfing": { lat: 48.1189, lng: 11.4289 },
    "grafenhainichen": { lat: 51.7167, lng: 12.4333 },
    "grafingbeimunchen": { lat: 48.05, lng: 11.9667 },
    "grefrath": { lat: 51.3333, lng: 6.3333 },
    "greifswald": { lat: 54.0833, lng: 13.3833 },
    "greiz": { lat: 50.6547, lng: 12.1997 },
    "grenzachwyhlen": { lat: 47.545, lng: 7.6758 },
    "greven": { lat: 52.0917, lng: 7.6083 },
    "grevenbroich": { lat: 51.0883, lng: 6.5875 },
    "grevesmuhlen": { lat: 53.8667, lng: 11.1667 },
    "griesheim": { lat: 49.8639, lng: 8.5639 },
    "grimma": { lat: 51.2386, lng: 12.7253 },
    "grimmen": { lat: 54.11, lng: 13.0414 },
    "grobenzell": { lat: 48.2, lng: 11.3667 },
    "gronau": { lat: 52.2125, lng: 7.0417 },
    "grosskreutz": { lat: 52.4, lng: 12.7833 },
    "grossgerau": { lat: 49.9192, lng: 8.485 },
    "grossumstadt": { lat: 49.8667, lng: 8.9333 },
    "grosszimmern": { lat: 49.8833, lng: 8.8333 },
    "grossbeeren": { lat: 52.3544, lng: 13.3061 },
    "grossbottwar": { lat: 49.0014, lng: 9.2931 },
    "grossburgwedel": { lat: 52.4933, lng: 9.8586 },
    "grossenhain": { lat: 51.2833, lng: 13.55 },
    "grossenkneten": { lat: 52.95, lng: 8.2667 },
    "grossenluder": { lat: 50.5833, lng: 9.5333 },
    "grosshansdorf": { lat: 53.6667, lng: 10.2667 },
    "grossostheim": { lat: 49.9167, lng: 9.0833 },
    "grossrohrsdorf": { lat: 51.1444, lng: 14.0167 },
    "grunberg": { lat: 50.6, lng: 8.95 },
    "grunheide": { lat: 52.4167, lng: 13.8167 },
    "grunstadt": { lat: 49.5692, lng: 8.1681 },
    "grunwald": { lat: 48.0333, lng: 11.5167 },
    "guben": { lat: 51.9533, lng: 14.7167 },
    "gudensberg": { lat: 51.1833, lng: 9.3667 },
    "gummersbach": { lat: 51.0333, lng: 7.5667 },
    "gundelfingen": { lat: 48.05, lng: 7.8667 },
    "gunzburg": { lat: 48.4527, lng: 10.2713 },
    "gunzenhausen": { lat: 49.1147, lng: 10.7542 },
    "gustrow": { lat: 53.7939, lng: 12.1764 },
    "gutersloh": { lat: 51.9, lng: 8.3833 },
    "haan": { lat: 51.1667, lng: 7 },
    "haar": { lat: 48.1, lng: 11.7333 },
    "haaren": { lat: 50.7956, lng: 6.1269 },
    "hadamar": { lat: 50.45, lng: 8.05 },
    "hagenimbremischen": { lat: 53.3667, lng: 8.65 },
    "hagen": { lat: 51.3667, lng: 7.4833 },
    "hagenow": { lat: 53.4167, lng: 11.1833 },
    "haibach": { lat: 49.9675, lng: 9.1969 },
    "haiger": { lat: 50.7422, lng: 8.2039 },
    "haigerloch": { lat: 48.3647, lng: 8.805 },
    "halberstadt": { lat: 51.8958, lng: 11.0467 },
    "haldensleben": { lat: 52.2833, lng: 11.4167 },
    "hallbergmoos": { lat: 48.3333, lng: 11.75 },
    "halle": { lat: 51.4828, lng: 11.9697 },
    "halleneustadt": { lat: 51.4789, lng: 11.9214 },
    "hallstadt": { lat: 49.9333, lng: 10.8833 },
    "halstenbek": { lat: 53.6333, lng: 9.8667 },
    "halver": { lat: 51.1833, lng: 7.4667 },
    "hambuhren": { lat: 52.6333, lng: 9.9833 },
    "hamburg": { lat: 53.55, lng: 10 },
    "hameln": { lat: 52.1, lng: 9.3667 },
    "hamm": { lat: 51.6833, lng: 7.8167 },
    "hammelburg": { lat: 50.1167, lng: 9.9 },
    "hamminkeln": { lat: 51.7319, lng: 6.5908 },
    "hanau": { lat: 50.1328, lng: 8.9169 },
    "handewitt": { lat: 54.7667, lng: 9.3167 },
    "hannover": { lat: 52.3667, lng: 9.7167 },
    "hannoverschmunden": { lat: 51.4167, lng: 9.65 },
    "haren": { lat: 52.7667, lng: 7.2167 },
    "harrislee": { lat: 54.7972, lng: 9.3764 },
    "harsefeld": { lat: 53.45, lng: 9.5 },
    "harsewinkel": { lat: 51.9667, lng: 8.2331 },
    "harsum": { lat: 52.2, lng: 9.95 },
    "hasbergen": { lat: 52.2167, lng: 7.9167 },
    "haselunne": { lat: 52.6667, lng: 7.4667 },
    "hassfurt": { lat: 50.0167, lng: 10.5 },
    "hassloch": { lat: 49.3631, lng: 8.2558 },
    "hatten": { lat: 53.0083, lng: 8.3167 },
    "hattersheim": { lat: 50.0722, lng: 8.4864 },
    "hattingen": { lat: 51.3992, lng: 7.1858 },
    "hauzenberg": { lat: 48.65, lng: 13.6333 },
    "havixbeck": { lat: 51.8111, lng: 7.4167 },
    "hechingen": { lat: 48.3517, lng: 8.9633 },
    "heddesheim": { lat: 49.5053, lng: 8.6033 },
    "heek": { lat: 52.1167, lng: 7.0997 },
    "heide": { lat: 54.1961, lng: 9.0933 },
    "heidelberg": { lat: 49.4167, lng: 8.7167 },
    "heiden": { lat: 51.8258, lng: 6.9331 },
    "heidenau": { lat: 50.9833, lng: 13.8667 },
    "heidenheim": { lat: 48.6761, lng: 10.1544 },
    "heikendorf": { lat: 54.3722, lng: 10.2081 },
    "heilbadheiligenstadt": { lat: 51.3789, lng: 10.1386 },
    "heilbronn": { lat: 49.15, lng: 9.2167 },
    "heiligenhafen": { lat: 54.3739, lng: 10.9797 },
    "heiligenhaus": { lat: 51.3167, lng: 6.9667 },
    "heilsbronn": { lat: 49.3167, lng: 10.8 },
    "heinsberg": { lat: 51.0631, lng: 6.0964 },
    "helmstedt": { lat: 52.2281, lng: 11.0106 },
    "hemau": { lat: 49.0519, lng: 11.7828 },
    "hemer": { lat: 51.3833, lng: 7.7667 },
    "hemmingen": { lat: 52.3236, lng: 9.7256 },
    "hemmoor": { lat: 53.7025, lng: 9.1394 },
    "hemsbach": { lat: 49.5903, lng: 8.6564 },
    "hennef": { lat: 50.7833, lng: 7.2833 },
    "hennigsdorf": { lat: 52.6378, lng: 13.2036 },
    "henstedtulzburg": { lat: 53.7833, lng: 10 },
    "heppenheim": { lat: 49.6431, lng: 8.6389 },
    "herbolzheim": { lat: 48.2219, lng: 7.7775 },
    "herborn": { lat: 50.6825, lng: 8.3061 },
    "herbrechtingen": { lat: 48.6253, lng: 10.1739 },
    "herdecke": { lat: 51.4, lng: 7.4333 },
    "herford": { lat: 52.1333, lng: 8.6833 },
    "hermsdorf": { lat: 50.8981, lng: 11.8567 },
    "herne": { lat: 51.55, lng: 7.2167 },
    "herrenberg": { lat: 48.5967, lng: 8.8708 },
    "herrschingamammersee": { lat: 48, lng: 11.1833 },
    "hersbruck": { lat: 49.5081, lng: 11.4328 },
    "herten": { lat: 51.6, lng: 7.1333 },
    "herxheim": { lat: 49.1469, lng: 8.22 },
    "herzbergamharz": { lat: 51.6575, lng: 10.3411 },
    "herzberg": { lat: 51.6833, lng: 13.2333 },
    "herzogenaurach": { lat: 49.57, lng: 10.8819 },
    "herzogenrath": { lat: 50.8667, lng: 6.1 },
    "hessischlichtenau": { lat: 51.2, lng: 9.7167 },
    "hessischoldendorf": { lat: 52.1667, lng: 9.25 },
    "hettstedt": { lat: 51.6333, lng: 11.5 },
    "heubach": { lat: 48.7881, lng: 9.9333 },
    "heusenstamm": { lat: 50.05, lng: 8.8 },
    "heusweiler": { lat: 49.35, lng: 6.9167 },
    "hiddenhausen": { lat: 52.1667, lng: 8.6167 },
    "hilchenbach": { lat: 50.9983, lng: 8.1094 },
    "hildburghausen": { lat: 50.4167, lng: 10.75 },
    "hilden": { lat: 51.1714, lng: 6.9394 },
    "hildesheim": { lat: 52.15, lng: 9.95 },
    "hille": { lat: 52.3331, lng: 8.75 },
    "hilpoltstein": { lat: 49.1833, lng: 11.1833 },
    "hilter": { lat: 52.15, lng: 8.15 },
    "hilzingen": { lat: 47.7653, lng: 8.7844 },
    "hirschaid": { lat: 49.8167, lng: 10.9833 },
    "hochberg": { lat: 49.7831, lng: 9.8817 },
    "hochheimammain": { lat: 50.0167, lng: 8.35 },
    "hochstimodenwald": { lat: 49.8, lng: 9 },
    "hochstadtanderaisch": { lat: 49.7, lng: 10.8 },
    "hockenheim": { lat: 49.3181, lng: 8.5472 },
    "hof": { lat: 50.3167, lng: 11.9167 },
    "hofgeismar": { lat: 51.4833, lng: 9.4 },
    "hofheim": { lat: 50.0833, lng: 8.45 },
    "hohenneuendorf": { lat: 52.6667, lng: 13.2833 },
    "hohenbrunn": { lat: 48.05, lng: 11.7 },
    "hohenhameln": { lat: 52.26, lng: 10.0664 },
    "hohenkirchensiegertsbrunn": { lat: 48.0167, lng: 11.7333 },
    "hohenmolsen": { lat: 51.1564, lng: 12.0981 },
    "hohensteinernstthal": { lat: 50.8, lng: 12.7167 },
    "hohrgrenzhausen": { lat: 50.435, lng: 7.6711 },
    "holzgerlingen": { lat: 48.6392, lng: 9.0108 },
    "holzkirchen": { lat: 47.8833, lng: 11.7 },
    "holzminden": { lat: 51.8297, lng: 9.4483 },
    "holzwickede": { lat: 51.5, lng: 7.6167 },
    "homburg": { lat: 49.3167, lng: 7.3333 },
    "honow": { lat: 52.5483, lng: 13.6378 },
    "hoppegarten": { lat: 52.5167, lng: 13.6667 },
    "horbamneckar": { lat: 48.4453, lng: 8.6911 },
    "hornbadmeinberg": { lat: 51.8833, lng: 8.9667 },
    "horstel": { lat: 52.2972, lng: 7.5861 },
    "hosbach": { lat: 50, lng: 9.2 },
    "hovelhof": { lat: 51.8167, lng: 8.65 },
    "hoxter": { lat: 51.7667, lng: 9.3667 },
    "hoyerswerda": { lat: 51.4333, lng: 14.25 },
    "huckelhoven": { lat: 51.0608, lng: 6.2197 },
    "huckeswagen": { lat: 51.145, lng: 7.3417 },
    "hude": { lat: 53.1111, lng: 8.4625 },
    "hullhorst": { lat: 52.2833, lng: 8.6667 },
    "hunfeld": { lat: 50.6667, lng: 9.7667 },
    "hungen": { lat: 50.4667, lng: 8.9 },
    "hunxe": { lat: 51.6417, lng: 6.7672 },
    "hurtgenwald": { lat: 50.71, lng: 6.3744 },
    "hurth": { lat: 50.8775, lng: 6.8761 },
    "husum": { lat: 54.4667, lng: 9.05 },
    "ibbenburen": { lat: 52.2778, lng: 7.7167 },
    "ichenhausen": { lat: 48.3667, lng: 10.3167 },
    "idstein": { lat: 50.2214, lng: 8.2697 },
    "illertissen": { lat: 48.2167, lng: 10.0833 },
    "illingen": { lat: 49.3667, lng: 7.0333 },
    "ilmenau": { lat: 50.6839, lng: 10.9194 },
    "ilsede": { lat: 52.2667, lng: 10.1833 },
    "ilsenburg": { lat: 51.8667, lng: 10.6833 },
    "ilsfeld": { lat: 49.05, lng: 9.25 },
    "ilvesheim": { lat: 49.4725, lng: 8.5675 },
    "immenstadtimallgau": { lat: 47.5667, lng: 10.2167 },
    "ingelheim": { lat: 49.9747, lng: 8.0564 },
    "ingolstadt": { lat: 48.7631, lng: 11.425 },
    "iserlohn": { lat: 51.3833, lng: 7.6667 },
    "isernhagensud": { lat: 52.4342, lng: 9.8572 },
    "ismaning": { lat: 48.2264, lng: 11.6725 },
    "isnyimallgau": { lat: 47.6919, lng: 10.0394 },
    "isselburg": { lat: 51.8331, lng: 6.4667 },
    "issum": { lat: 51.5389, lng: 6.4236 },
    "itzehoe": { lat: 53.925, lng: 9.5164 },
    "jena": { lat: 50.9272, lng: 11.5861 },
    "jever": { lat: 53.5744, lng: 7.9008 },
    "jork": { lat: 53.5344, lng: 9.6817 },
    "juchen": { lat: 51.1011, lng: 6.5017 },
    "julich": { lat: 50.9222, lng: 6.3583 },
    "juterbog": { lat: 51.9933, lng: 13.0728 },
    "kaarst": { lat: 51.2167, lng: 6.6167 },
    "kaiserslautern": { lat: 49.4447, lng: 7.7689 },
    "kaldenkirchen": { lat: 51.3167, lng: 6.2833 },
    "kalkar": { lat: 51.7389, lng: 6.2925 },
    "kall": { lat: 50.55, lng: 6.55 },
    "kaltenkirchen": { lat: 53.8397, lng: 9.9603 },
    "kamen": { lat: 51.5917, lng: 7.6653 },
    "kamenz": { lat: 51.2667, lng: 14.1 },
    "kamplintfort": { lat: 51.5, lng: 6.5333 },
    "kandel": { lat: 49.0833, lng: 8.2 },
    "kappeln": { lat: 54.6614, lng: 9.9311 },
    "karben": { lat: 50.2322, lng: 8.7681 },
    "karlsdorfneuthard": { lat: 49.1364, lng: 8.5439 },
    "karlsfeld": { lat: 48.2167, lng: 11.4667 },
    "karlsruhe": { lat: 49.0092, lng: 8.404 },
    "kassel": { lat: 51.3158, lng: 9.4979 },
    "kaufbeuren": { lat: 47.88, lng: 10.6225 },
    "kaufering": { lat: 48.0833, lng: 10.8833 },
    "kaufungen": { lat: 51.2811, lng: 9.6186 },
    "kehl": { lat: 48.5667, lng: 7.8167 },
    "kelheim": { lat: 48.9167, lng: 11.8667 },
    "kelkheimtaunus": { lat: 50.1378, lng: 8.4497 },
    "kelsterbach": { lat: 50.0617, lng: 8.5311 },
    "kemberg": { lat: 51.7833, lng: 12.6333 },
    "kempen": { lat: 51.3658, lng: 6.4194 },
    "kempten": { lat: 47.7333, lng: 10.3167 },
    "kenzingen": { lat: 48.1917, lng: 7.7683 },
    "kerpen": { lat: 50.8719, lng: 6.6961 },
    "ketsch": { lat: 49.3658, lng: 8.5336 },
    "kevelaer": { lat: 51.5833, lng: 6.25 },
    "kiel": { lat: 54.3233, lng: 10.1394 },
    "kierspe": { lat: 51.1333, lng: 7.5667 },
    "kirchhain": { lat: 50.8167, lng: 8.9167 },
    "kirchhatten": { lat: 53.0184, lng: 8.35 },
    "kirchheimbeimunchen": { lat: 48.1833, lng: 11.75 },
    "kirchheimunterteck": { lat: 48.6483, lng: 9.4511 },
    "kirchhundem": { lat: 51.0667, lng: 8.0833 },
    "kirchlengern": { lat: 52.2, lng: 8.6331 },
    "kirchlinteln": { lat: 52.9428, lng: 9.3183 },
    "kirchseeon": { lat: 48.0731, lng: 11.8861 },
    "kirchzarten": { lat: 47.965, lng: 7.9556 },
    "kirkel": { lat: 49.2833, lng: 7.2333 },
    "kirn": { lat: 49.7881, lng: 7.4572 },
    "kissing": { lat: 48.3, lng: 10.9833 },
    "kisslegg": { lat: 47.79, lng: 9.8842 },
    "kitzingen": { lat: 49.7333, lng: 10.1667 },
    "kleinblittersdorf": { lat: 49.1583, lng: 7.0361 },
    "kleve": { lat: 51.79, lng: 6.14 },
    "klipphausen": { lat: 51.0833, lng: 13.5333 },
    "klotze": { lat: 52.6263, lng: 11.1616 },
    "koblenz": { lat: 50.3597, lng: 7.5978 },
    "kolbermoor": { lat: 47.85, lng: 12.0667 },
    "kolkwitz": { lat: 51.75, lng: 14.25 },
    "kongen": { lat: 48.6819, lng: 9.3667 },
    "konigswusterhausen": { lat: 52.2917, lng: 13.625 },
    "konigsbachstein": { lat: 48.9664, lng: 8.6089 },
    "konigsbrunn": { lat: 48.2689, lng: 10.8908 },
    "konigslutteramelm": { lat: 52.25, lng: 10.8167 },
    "konigsteinimtaunus": { lat: 50.1833, lng: 8.4667 },
    "konigswinter": { lat: 50.6736, lng: 7.1947 },
    "konstanz": { lat: 47.6667, lng: 9.1833 },
    "konz": { lat: 49.7, lng: 6.5833 },
    "korb": { lat: 48.8417, lng: 9.3611 },
    "korbach": { lat: 51.2833, lng: 8.8667 },
    "korntalmunchingen": { lat: 48.8306, lng: 9.1214 },
    "kornwestheim": { lat: 48.8598, lng: 9.1852 },
    "korschenbroich": { lat: 51.1833, lng: 6.5167 },
    "kosching": { lat: 48.8167, lng: 11.5 },
    "kranenburg": { lat: 51.7897, lng: 6.0072 },
    "krefeld": { lat: 51.3333, lng: 6.5667 },
    "kressbronnambodensee": { lat: 47.5958, lng: 9.6 },
    "kreuzau": { lat: 50.75, lng: 6.4831 },
    "kreuztal": { lat: 50.9667, lng: 7.9667 },
    "kriftel": { lat: 50.0833, lng: 8.45 },
    "kronach": { lat: 50.2411, lng: 11.3281 },
    "kronberg": { lat: 50.1833, lng: 8.5 },
    "kronshagen": { lat: 54.3333, lng: 10.0833 },
    "krumbach": { lat: 48.25, lng: 10.3667 },
    "kulmbach": { lat: 50.1, lng: 11.4333 },
    "kummersbruck": { lat: 49.4167, lng: 11.8833 },
    "kunzell": { lat: 50.55, lng: 9.7167 },
    "kunzelsau": { lat: 49.2833, lng: 9.6833 },
    "kuppenheim": { lat: 48.8275, lng: 8.2544 },
    "kurortsteinbachhallenberg": { lat: 50.7006, lng: 10.5667 },
    "kurten": { lat: 51.0497, lng: 7.2667 },
    "kusterdingen": { lat: 48.5312, lng: 9.1484 },
    "kyritz": { lat: 52.95, lng: 12.4 },
    "laatzen": { lat: 52.3167, lng: 9.8 },
    "ladenburg": { lat: 49.4667, lng: 8.6167 },
    "lage": { lat: 51.9889, lng: 8.7944 },
    "lahnstein": { lat: 50.3011, lng: 7.6056 },
    "lahstedt": { lat: 52.25, lng: 10.2167 },
    "laichingen": { lat: 48.4897, lng: 9.6861 },
    "lampertheim": { lat: 49.6, lng: 8.4667 },
    "landauanderisar": { lat: 48.6667, lng: 12.6667 },
    "landau": { lat: 49.2, lng: 8.1167 },
    "landsberg": { lat: 48.0478, lng: 10.8989 },
    "landshut": { lat: 48.5397, lng: 12.1508 },
    "langelsheim": { lat: 51.9381, lng: 10.335 },
    "langen": { lat: 49.9833, lng: 8.6667 },
    "langenau": { lat: 48.4967, lng: 10.12 },
    "langenberg": { lat: 51.3519, lng: 7.1217 },
    "langenfeld": { lat: 51.1167, lng: 6.95 },
    "langenhagen": { lat: 52.4394, lng: 9.74 },
    "langenselbold": { lat: 50.1833, lng: 9.0333 },
    "langenzenn": { lat: 49.4944, lng: 10.7947 },
    "langerwehe": { lat: 50.8167, lng: 6.3497 },
    "langgons": { lat: 50.5, lng: 8.6667 },
    "langwedel": { lat: 52.9667, lng: 9.2167 },
    "lappersdorf": { lat: 49.0525, lng: 12.0903 },
    "laubach": { lat: 50.5333, lng: 8.99 },
    "lauchhammer": { lat: 51.5, lng: 13.8 },
    "laudakonigshofen": { lat: 49.5686, lng: 9.7039 },
    "lauenburg": { lat: 53.3833, lng: 10.5667 },
    "lauf": { lat: 49.5103, lng: 11.2772 },
    "laufenburgbaden": { lat: 47.5656, lng: 8.0647 },
    "lauffenamneckar": { lat: 49.0833, lng: 9.15 },
    "lauingen": { lat: 48.5667, lng: 10.4333 },
    "laupheim": { lat: 48.2289, lng: 9.8797 },
    "lauterbach": { lat: 50.6378, lng: 9.3944 },
    "lebach": { lat: 49.41, lng: 6.91 },
    "leer": { lat: 53.2308, lng: 7.4528 },
    "lehre": { lat: 52.3167, lng: 10.6667 },
    "lehrte": { lat: 52.3667, lng: 9.9667 },
    "leichlingen": { lat: 51.1167, lng: 7.0167 },
    "leimen": { lat: 49.3481, lng: 8.6911 },
    "leinefelde": { lat: 51.3833, lng: 10.3333 },
    "leinfeldenechterdingen": { lat: 48.6928, lng: 9.1428 },
    "leingarten": { lat: 49.15, lng: 9.1167 },
    "leipzig": { lat: 51.34, lng: 12.375 },
    "lemgo": { lat: 52.0272, lng: 8.9117 },
    "lengede": { lat: 52.2, lng: 10.3 },
    "lengerich": { lat: 52.175, lng: 7.8667 },
    "lenggries": { lat: 47.6803, lng: 11.5739 },
    "lennestadt": { lat: 51.1236, lng: 8.0681 },
    "leonberg": { lat: 48.8014, lng: 9.0131 },
    "leopoldshohe": { lat: 52.0167, lng: 8.6914 },
    "leuna": { lat: 51.3167, lng: 12.0167 },
    "leutenbach": { lat: 48.8883, lng: 9.3914 },
    "leutkirchimallgau": { lat: 47.8256, lng: 10.0222 },
    "leverkusen": { lat: 51.0333, lng: 6.9833 },
    "lich": { lat: 50.5217, lng: 8.8208 },
    "lichtenau": { lat: 51.6, lng: 8.8833 },
    "lichtenfels": { lat: 50.1333, lng: 11.0333 },
    "lichtenstein": { lat: 50.7564, lng: 12.6317 },
    "lienen": { lat: 52.1461, lng: 7.9739 },
    "limbachoberfrohna": { lat: 50.8667, lng: 12.75 },
    "limburg": { lat: 50.3833, lng: 8.0667 },
    "limburgerhof": { lat: 49.4167, lng: 8.4 },
    "lindau": { lat: 47.5458, lng: 9.6833 },
    "lindenbergimallgau": { lat: 47.6, lng: 9.9 },
    "lindlar": { lat: 51.0167, lng: 7.3833 },
    "lingen": { lat: 52.5231, lng: 7.3231 },
    "linkenheimhochstetten": { lat: 49.1261, lng: 8.41 },
    "linnich": { lat: 50.9789, lng: 6.2678 },
    "lippstadt": { lat: 51.6667, lng: 8.35 },
    "lobau": { lat: 51.0944, lng: 14.6667 },
    "lohfelden": { lat: 51.2667, lng: 9.5333 },
    "lohmar": { lat: 50.8167, lng: 7.2167 },
    "lohne": { lat: 52.2, lng: 8.7 },
    "lollar": { lat: 50.6497, lng: 8.7044 },
    "loningen": { lat: 52.7167, lng: 7.7667 },
    "lorch": { lat: 48.7983, lng: 9.6883 },
    "lorrach": { lat: 47.6167, lng: 7.6667 },
    "lorsch": { lat: 49.6539, lng: 8.5675 },
    "lotte": { lat: 52.2764, lng: 7.9167 },
    "lowenberg": { lat: 52.8833, lng: 13.15 },
    "loxstedt": { lat: 53.4667, lng: 8.65 },
    "lubbecke": { lat: 52.3081, lng: 8.6231 },
    "lubbenspreewald": { lat: 51.95, lng: 13.9 },
    "lubbenauspreewald": { lat: 51.8667, lng: 13.9667 },
    "lubeck": { lat: 53.8697, lng: 10.6864 },
    "luchow": { lat: 52.9667, lng: 11.15 },
    "luckau": { lat: 51.85, lng: 13.7167 },
    "luckenwalde": { lat: 52.0833, lng: 13.1667 },
    "ludenscheid": { lat: 51.2167, lng: 7.6333 },
    "ludinghausen": { lat: 51.7667, lng: 7.4333 },
    "ludwigsburg": { lat: 48.8975, lng: 9.1922 },
    "ludwigsfelde": { lat: 52.2997, lng: 13.2667 },
    "ludwigshafen": { lat: 49.4811, lng: 8.4353 },
    "ludwigslust": { lat: 53.3244, lng: 11.4972 },
    "luneburg": { lat: 53.2525, lng: 10.4144 },
    "lunen": { lat: 51.6167, lng: 7.5167 },
    "magdeburg": { lat: 52.1317, lng: 11.6392 },
    "magstadt": { lat: 48.7422, lng: 8.965 },
    "mainaschaff": { lat: 49.9833, lng: 9.0833 },
    "mainburg": { lat: 48.65, lng: 11.7833 },
    "maintal": { lat: 50.15, lng: 8.8333 },
    "mainz": { lat: 49.9994, lng: 8.2736 },
    "maisach": { lat: 48.2167, lng: 11.2667 },
    "maisenhausen": { lat: 50.0167, lng: 9 },
    "malente": { lat: 54.1667, lng: 10.55 },
    "malsch": { lat: 48.8808, lng: 8.3342 },
    "manching": { lat: 48.7186, lng: 11.4972 },
    "mannheim": { lat: 49.4878, lng: 8.4661 },
    "marbachamneckar": { lat: 48.9333, lng: 9.25 },
    "marburg": { lat: 50.81, lng: 8.7708 },
    "marienberg": { lat: 50.6333, lng: 13.15 },
    "marienheide": { lat: 51.0833, lng: 7.5333 },
    "markdorf": { lat: 47.7208, lng: 9.3917 },
    "markgroningen": { lat: 48.9047, lng: 9.0808 },
    "markkleeberg": { lat: 51.2778, lng: 12.3833 },
    "markranstadt": { lat: 51.3017, lng: 12.2211 },
    "marktindersdorf": { lat: 48.3667, lng: 11.3667 },
    "marktschwaben": { lat: 48.1911, lng: 11.8681 },
    "marktheidenfeld": { lat: 49.85, lng: 9.6 },
    "marktoberdorf": { lat: 47.7667, lng: 10.6167 },
    "marktredwitz": { lat: 50, lng: 12.0667 },
    "marl": { lat: 51.6667, lng: 7.1167 },
    "marpingen": { lat: 49.45, lng: 7.05 },
    "marsberg": { lat: 51.45, lng: 8.8333 },
    "maxhuttehaidhof": { lat: 49.2, lng: 12.1 },
    "mayen": { lat: 50.3333, lng: 7.2167 },
    "mechernich": { lat: 50.6, lng: 6.65 },
    "meckenbeuren": { lat: 47.7, lng: 9.5625 },
    "meckenheim": { lat: 50.6333, lng: 7.0167 },
    "meerane": { lat: 50.8519, lng: 12.4636 },
    "meerbusch": { lat: 51.2667, lng: 6.6667 },
    "meine": { lat: 52.3833, lng: 10.5333 },
    "meinerzhagen": { lat: 51.1167, lng: 7.6333 },
    "meiningen": { lat: 50.55, lng: 10.4167 },
    "meissen": { lat: 51.1667, lng: 13.4833 },
    "meitingen": { lat: 48.5333, lng: 10.8333 },
    "melle": { lat: 52.2044, lng: 8.3389 },
    "melsungen": { lat: 51.1333, lng: 9.55 },
    "memmelsdorf": { lat: 49.9328, lng: 10.9533 },
    "memmingen": { lat: 47.9878, lng: 10.1811 },
    "mendig": { lat: 50.3744, lng: 7.2808 },
    "mengen": { lat: 48.0497, lng: 9.33 },
    "meppen": { lat: 52.6936, lng: 7.2928 },
    "merchweiler": { lat: 49.35, lng: 7.0333 },
    "mering": { lat: 48.2625, lng: 10.9844 },
    "merseburg": { lat: 51.3544, lng: 11.9928 },
    "merzenich": { lat: 50.8333, lng: 6.5333 },
    "merzig": { lat: 49.45, lng: 6.6167 },
    "meschede": { lat: 51.35, lng: 8.2833 },
    "messkirch": { lat: 47.9928, lng: 9.1125 },
    "messstetten": { lat: 48.1806, lng: 8.9625 },
    "mettingen": { lat: 52.3167, lng: 7.7806 },
    "mettlach": { lat: 49.4942, lng: 6.6052 },
    "mettmann": { lat: 51.25, lng: 6.9667 },
    "metzingen": { lat: 48.5367, lng: 9.2858 },
    "meuselwitz": { lat: 51.05, lng: 12.3 },
    "michelstadt": { lat: 49.6786, lng: 9.0039 },
    "michendorf": { lat: 52.3, lng: 13.0167 },
    "miesbach": { lat: 47.7833, lng: 11.8333 },
    "miltenberg": { lat: 49.7039, lng: 9.2644 },
    "mindelheim": { lat: 48.0333, lng: 10.4667 },
    "minden": { lat: 52.2883, lng: 8.9167 },
    "mittegrossefehn": { lat: 53.3833, lng: 7.5833 },
    "mittenwalde": { lat: 52.2667, lng: 13.5333 },
    "mittweida": { lat: 50.9856, lng: 12.9811 },
    "mockern": { lat: 52.1406, lng: 11.9525 },
    "mockmuhl": { lat: 49.3167, lng: 9.35 },
    "moers": { lat: 51.4592, lng: 6.6197 },
    "moglingen": { lat: 48.8883, lng: 9.1292 },
    "mohnesee": { lat: 51.4958, lng: 8.1306 },
    "molbergen": { lat: 52.8667, lng: 7.9333 },
    "molln": { lat: 53.6269, lng: 10.6847 },
    "mombris": { lat: 50.0667, lng: 9.1667 },
    "monchengladbach": { lat: 51.2, lng: 6.4333 },
    "monschau": { lat: 50.56, lng: 6.2564 },
    "montabaur": { lat: 50.4375, lng: 7.8258 },
    "moosburg": { lat: 48.4667, lng: 11.9333 },
    "morbach": { lat: 49.8167, lng: 7.1167 },
    "morfeldenwalldorf": { lat: 50, lng: 8.5833 },
    "morlenbach": { lat: 49.5992, lng: 8.7347 },
    "morsbach": { lat: 50.8667, lng: 7.7167 },
    "mosbach": { lat: 49.3522, lng: 9.1467 },
    "mossingen": { lat: 48.4064, lng: 9.0575 },
    "much": { lat: 50.9167, lng: 7.4 },
    "muhlacker": { lat: 48.95, lng: 8.8394 },
    "muhldorf": { lat: 48.2456, lng: 12.5228 },
    "muhlhausen": { lat: 49.2475, lng: 8.7239 },
    "mulheim": { lat: 51.4275, lng: 6.8825 },
    "mulheimkarlich": { lat: 50.3869, lng: 7.4953 },
    "mullheim": { lat: 47.8, lng: 7.6333 },
    "mulsen": { lat: 50.7447, lng: 12.5747 },
    "munchberg": { lat: 50.2, lng: 11.7667 },
    "munich": { lat: 48.1375, lng: 11.575 },
    "munsingen": { lat: 48.4128, lng: 9.4953 },
    "munster": { lat: 49.9167, lng: 8.8667 },
    "murnauamstaffelsee": { lat: 47.6833, lng: 11.2 },
    "murrhardt": { lat: 48.98, lng: 9.5814 },
    "mutterstadt": { lat: 49.4333, lng: 8.35 },
    "nagold": { lat: 48.5519, lng: 8.7256 },
    "nalbach": { lat: 49.3667, lng: 6.7667 },
    "nauen": { lat: 52.6, lng: 12.8831 },
    "nauheim": { lat: 49.9506, lng: 8.4631 },
    "naumburg": { lat: 51.15, lng: 11.8167 },
    "naunhof": { lat: 51.2778, lng: 12.5883 },
    "neckargemund": { lat: 49.3939, lng: 8.7975 },
    "neckarsulm": { lat: 49.1917, lng: 9.2246 },
    "nersingen": { lat: 48.4289, lng: 10.1219 },
    "netphen": { lat: 50.9147, lng: 8.1 },
    "nettersheim": { lat: 50.4925, lng: 6.6297 },
    "nettetal": { lat: 51.3167, lng: 6.2833 },
    "neubleckede": { lat: 53.3, lng: 10.7333 },
    "neuisenburg": { lat: 50.05, lng: 8.7 },
    "neuanspach": { lat: 50.2931, lng: 8.5089 },
    "neuulm": { lat: 48.3833, lng: 10 },
    "neubiberg": { lat: 48.0833, lng: 11.6833 },
    "neubrandenburg": { lat: 53.5569, lng: 13.2611 },
    "neuburg": { lat: 48.7333, lng: 11.1833 },
    "neuenburgamrhein": { lat: 47.8147, lng: 7.5619 },
    "neuenburg": { lat: 48.8461, lng: 8.5889 },
    "neuenhaus": { lat: 52.5, lng: 6.9667 },
    "neuenkirchen": { lat: 52.2411, lng: 7.3689 },
    "neuenrade": { lat: 51.2839, lng: 7.78 },
    "neuenstadtamkocher": { lat: 49.2333, lng: 9.3333 },
    "neufahrnbeifreising": { lat: 48.3167, lng: 11.6667 },
    "neuhausamrennweg": { lat: 50.5167, lng: 11.15 },
    "neuhausenaufdenfildern": { lat: 48.6844, lng: 9.2744 },
    "neuhof": { lat: 50.4333, lng: 9.6167 },
    "neumarkt": { lat: 49.2833, lng: 11.4667 },
    "neumunster": { lat: 54.0714, lng: 9.99 },
    "neunkirchen": { lat: 49.35, lng: 7.1667 },
    "neuotting": { lat: 48.2167, lng: 12.6833 },
    "neuried": { lat: 48.0933, lng: 11.4658 },
    "neuruppin": { lat: 52.9331, lng: 12.8 },
    "neusass": { lat: 48.4, lng: 10.8333 },
    "neuss": { lat: 51.2, lng: 6.7 },
    "neustadtamrubenberge": { lat: 52.5, lng: 9.4667 },
    "neustadtanderdonau": { lat: 48.8, lng: 11.7667 },
    "neustadtbeicoburg": { lat: 50.3289, lng: 11.1211 },
    "neustadtinholstein": { lat: 54.1072, lng: 10.8158 },
    "neustadt": { lat: 49.35, lng: 8.15 },
    "neustrelitz": { lat: 53.3647, lng: 13.0636 },
    "neutraubling": { lat: 48.9936, lng: 12.1953 },
    "neuwied": { lat: 50.4286, lng: 7.4614 },
    "neviges": { lat: 51.3128, lng: 7.0869 },
    "nidda": { lat: 50.4128, lng: 9.0092 },
    "nidderau": { lat: 50.25, lng: 8.9 },
    "nideggen": { lat: 50.7, lng: 6.4833 },
    "niebull": { lat: 54.7881, lng: 8.8296 },
    "niederolm": { lat: 49.9083, lng: 8.2028 },
    "niederkassel": { lat: 50.8167, lng: 7.0333 },
    "niederkruchten": { lat: 51.1989, lng: 6.2194 },
    "niedernhausen": { lat: 50.1667, lng: 8.3167 },
    "niederzier": { lat: 50.8831, lng: 6.4667 },
    "niefernoschelbronn": { lat: 48.9164, lng: 8.7842 },
    "nierstein": { lat: 49.8694, lng: 8.3375 },
    "niesky": { lat: 51.3, lng: 14.8167 },
    "nittenau": { lat: 49.2, lng: 12.2667 },
    "nohfelden": { lat: 49.5667, lng: 7.15 },
    "norden": { lat: 53.5967, lng: 7.2056 },
    "nordenham": { lat: 53.5, lng: 8.4667 },
    "norderstedt": { lat: 53.7064, lng: 10.0103 },
    "nordhausen": { lat: 51.505, lng: 10.7911 },
    "nordhorn": { lat: 52.4319, lng: 7.0678 },
    "nordkirchen": { lat: 51.7381, lng: 7.5256 },
    "nordlingen": { lat: 48.8511, lng: 10.4883 },
    "nordstemmen": { lat: 52.1667, lng: 9.7667 },
    "nordwalde": { lat: 52.0833, lng: 7.4833 },
    "nortenhardenberg": { lat: 51.6167, lng: 9.9333 },
    "northeim": { lat: 51.7067, lng: 10.0011 },
    "norvenich": { lat: 50.8, lng: 6.65 },
    "nossen": { lat: 51.05, lng: 13.3 },
    "nottuln": { lat: 51.9167, lng: 7.2833 },
    "numbrecht": { lat: 50.9053, lng: 7.5422 },
    "nuremberg": { lat: 49.4539, lng: 11.0775 },
    "nurtingen": { lat: 48.6333, lng: 9.3333 },
    "nussloch": { lat: 49.3236, lng: 8.6939 },
    "oberramstadt": { lat: 49.8333, lng: 8.75 },
    "oberasbach": { lat: 49.4219, lng: 10.9583 },
    "oberderdingen": { lat: 49.0625, lng: 8.8019 },
    "oberhaching": { lat: 48.0167, lng: 11.5833 },
    "oberhausen": { lat: 51.4967, lng: 6.8706 },
    "oberhausenrheinhausen": { lat: 49.2606, lng: 8.485 },
    "oberkirch": { lat: 48.5333, lng: 8.0833 },
    "obernburgammain": { lat: 49.84, lng: 9.1414 },
    "obernkirchen": { lat: 52.2664, lng: 9.1178 },
    "oberschleissheim": { lat: 48.25, lng: 11.5667 },
    "oberstdorf": { lat: 47.4167, lng: 10.2833 },
    "obertraubling": { lat: 48.9658, lng: 12.1669 },
    "obertshausen": { lat: 50.0667, lng: 8.8333 },
    "ochsenfurt": { lat: 49.65, lng: 10.0667 },
    "ochsenhausen": { lat: 48.0722, lng: 9.9481 },
    "ochtrup": { lat: 52.2056, lng: 7.1903 },
    "odenthal": { lat: 51.0333, lng: 7.1167 },
    "oelde": { lat: 51.8333, lng: 8.15 },
    "oelsnitz": { lat: 50.4167, lng: 12.1667 },
    "oererkenschwick": { lat: 51.6422, lng: 7.2508 },
    "oerlinghausen": { lat: 51.9667, lng: 8.6667 },
    "oestrichwinkel": { lat: 50.0025, lng: 8.0175 },
    "offenburg": { lat: 48.4667, lng: 7.9333 },
    "oftersheim": { lat: 49.3706, lng: 8.5847 },
    "ohrdruf": { lat: 50.8281, lng: 10.7328 },
    "ohringen": { lat: 49.2, lng: 9.5 },
    "olbernhau": { lat: 50.6667, lng: 13.3333 },
    "oldenburginholstein": { lat: 54.3, lng: 10.8833 },
    "oldenburg": { lat: 53.1439, lng: 8.2139 },
    "olfen": { lat: 51.7167, lng: 7.3833 },
    "olpe": { lat: 51.0167, lng: 7.8333 },
    "olsberg": { lat: 51.35, lng: 8.4833 },
    "oranienburg": { lat: 52.7544, lng: 13.2369 },
    "ortenberg": { lat: 50.3558, lng: 9.0553 },
    "oschatz": { lat: 51.3003, lng: 13.1072 },
    "oschersleben": { lat: 52.0167, lng: 11.25 },
    "osnabruck": { lat: 52.2833, lng: 8.05 },
    "ostbevern": { lat: 52.0389, lng: 7.8458 },
    "osterburg": { lat: 52.7833, lng: 11.7667 },
    "ostercappeln": { lat: 52.35, lng: 8.2333 },
    "osterhofen": { lat: 48.7019, lng: 13.02 },
    "osterholzscharmbeck": { lat: 53.2167, lng: 8.8 },
    "osterode": { lat: 51.7286, lng: 10.2522 },
    "osterwieck": { lat: 51.9667, lng: 10.7167 },
    "ostfildern": { lat: 48.7333, lng: 9.25 },
    "osthofen": { lat: 49.7078, lng: 8.3289 },
    "ostrhauderfehn": { lat: 53.1167, lng: 7.6167 },
    "ostringen": { lat: 49.2194, lng: 8.7108 },
    "oststeinbek": { lat: 53.5442, lng: 10.1664 },
    "ottendorfokrilla": { lat: 51.1792, lng: 13.8261 },
    "ottobeuren": { lat: 47.9414, lng: 10.2994 },
    "ottobrunn": { lat: 48.0667, lng: 11.6667 },
    "ottweiler": { lat: 49.3667, lng: 7.1667 },
    "overath": { lat: 50.95, lng: 7.3 },
    "oyten": { lat: 53.0611, lng: 9.0178 },
    "paderborn": { lat: 51.7181, lng: 8.7542 },
    "papenburg": { lat: 53.0667, lng: 7.4 },
    "parchim": { lat: 53.4167, lng: 11.8333 },
    "pasewalk": { lat: 53.5, lng: 14 },
    "passau": { lat: 48.5744, lng: 13.4647 },
    "pattensen": { lat: 52.2667, lng: 9.7667 },
    "pegnitz": { lat: 49.7564, lng: 11.545 },
    "peine": { lat: 52.3203, lng: 10.2336 },
    "peissenberg": { lat: 47.795, lng: 11.0603 },
    "peiting": { lat: 47.8, lng: 10.9333 },
    "penzberg": { lat: 47.75, lng: 11.3833 },
    "perl": { lat: 49.4667, lng: 6.3667 },
    "perleberg": { lat: 53.0667, lng: 11.8667 },
    "petersberg": { lat: 50.5667, lng: 9.7167 },
    "petershagen": { lat: 52.3833, lng: 8.9667 },
    "pfaffenhofen": { lat: 48.5333, lng: 11.5167 },
    "pfarrkirchen": { lat: 48.4167, lng: 12.9167 },
    "pfedelbach": { lat: 49.1833, lng: 9.5 },
    "pforzheim": { lat: 48.895, lng: 8.705 },
    "pfullendorf": { lat: 47.9242, lng: 9.2567 },
    "pfullingen": { lat: 48.4656, lng: 9.2261 },
    "pfungstadt": { lat: 49.8056, lng: 8.6044 },
    "philippsburg": { lat: 49.2333, lng: 8.45 },
    "pinneberg": { lat: 53.6333, lng: 9.8 },
    "pirmasens": { lat: 49.2, lng: 7.6 },
    "pirna": { lat: 50.9622, lng: 13.9403 },
    "planegg": { lat: 48.1047, lng: 11.4306 },
    "plankstadt": { lat: 49.3933, lng: 8.5942 },
    "plattling": { lat: 48.7667, lng: 12.8667 },
    "plauen": { lat: 50.4833, lng: 12.1167 },
    "plettenberg": { lat: 51.2167, lng: 7.8833 },
    "pliezhausen": { lat: 48.5586, lng: 9.2058 },
    "plochingen": { lat: 48.7117, lng: 9.4164 },
    "plon": { lat: 54.1622, lng: 10.4214 },
    "pluderhausen": { lat: 48.795, lng: 9.6011 },
    "pocking": { lat: 48.4, lng: 13.3167 },
    "poing": { lat: 48.1667, lng: 11.8167 },
    "portawestfalica": { lat: 52.2167, lng: 8.9333 },
    "possneck": { lat: 50.7, lng: 11.6 },
    "potsdam": { lat: 52.4006, lng: 13.0592 },
    "preetz": { lat: 54.2367, lng: 10.2822 },
    "prenzlau": { lat: 53.3167, lng: 13.8667 },
    "preussischoldendorf": { lat: 52.2833, lng: 8.5 },
    "prienamchiemsee": { lat: 47.8667, lng: 12.3333 },
    "pritzwalk": { lat: 53.15, lng: 12.1833 },
    "puchheim": { lat: 48.15, lng: 11.35 },
    "pulheim": { lat: 51, lng: 6.8 },
    "pullachimisartal": { lat: 48.05, lng: 11.5167 },
    "puttlingen": { lat: 49.2833, lng: 6.8833 },
    "quakenbruck": { lat: 52.6772, lng: 7.9575 },
    "quedlinburg": { lat: 51.7917, lng: 11.1472 },
    "querfurt": { lat: 51.3833, lng: 11.6 },
    "quickborn": { lat: 53.7333, lng: 9.8972 },
    "quierschied": { lat: 49.3167, lng: 7.0333 },
    "radeberg": { lat: 51.1167, lng: 13.9167 },
    "radebeul": { lat: 51.1, lng: 13.65 },
    "radevormwald": { lat: 51.2, lng: 7.35 },
    "radolfzellambodensee": { lat: 47.7333, lng: 8.9667 },
    "raesfeld": { lat: 51.7667, lng: 6.8333 },
    "rahden": { lat: 52.4167, lng: 8.6167 },
    "rain": { lat: 48.6833, lng: 10.9167 },
    "rangsdorf": { lat: 52.2833, lng: 13.4333 },
    "rastatt": { lat: 48.85, lng: 8.2 },
    "rastede": { lat: 53.25, lng: 8.2 },
    "ratekau": { lat: 53.95, lng: 10.7333 },
    "rathenow": { lat: 52.6, lng: 12.3333 },
    "ratingen": { lat: 51.3, lng: 6.85 },
    "ratzeburg": { lat: 53.7, lng: 10.75 },
    "raubling": { lat: 47.7881, lng: 12.1047 },
    "rauenberg": { lat: 49.2678, lng: 8.7036 },
    "raunheim": { lat: 50.0167, lng: 8.45 },
    "ravensburg": { lat: 47.7831, lng: 9.6114 },
    "recke": { lat: 52.37, lng: 7.7189 },
    "recklinghausen": { lat: 51.585, lng: 7.1619 },
    "rees": { lat: 51.7667, lng: 6.4 },
    "regen": { lat: 48.9667, lng: 13.1333 },
    "regensburg": { lat: 49.0167, lng: 12.0833 },
    "regenstauf": { lat: 49.1236, lng: 12.1283 },
    "rehau": { lat: 50.25, lng: 12.0167 },
    "rehburgloccum": { lat: 52.4508, lng: 9.2078 },
    "rehlingensiersburg": { lat: 49.3686, lng: 6.6786 },
    "reichenbachanderfils": { lat: 48.71, lng: 9.4661 },
    "reichenbachvogtland": { lat: 50.6167, lng: 12.3 },
    "reinbek": { lat: 53.5089, lng: 10.2483 },
    "reinfeld": { lat: 53.8333, lng: 10.4833 },
    "reinheim": { lat: 49.8269, lng: 8.8308 },
    "reiskirchen": { lat: 50.6, lng: 8.8333 },
    "rellingen": { lat: 53.65, lng: 9.8167 },
    "remagen": { lat: 50.5786, lng: 7.2306 },
    "remscheid": { lat: 51.1833, lng: 7.2 },
    "rendsburg": { lat: 54.3, lng: 9.6667 },
    "renningen": { lat: 48.7661, lng: 8.9347 },
    "rethen": { lat: 52.2861, lng: 9.825 },
    "reutlingen": { lat: 48.4833, lng: 9.2167 },
    "rhaude": { lat: 53.1667, lng: 7.55 },
    "rhedawiedenbruck": { lat: 51.8417, lng: 8.3 },
    "rhede": { lat: 51.8333, lng: 6.7006 },
    "rheinau": { lat: 48.6678, lng: 7.9347 },
    "rheinbach": { lat: 50.6333, lng: 6.95 },
    "rheinberg": { lat: 51.5467, lng: 6.6006 },
    "rheine": { lat: 52.2833, lng: 7.4333 },
    "rheinfeldenbaden": { lat: 47.5611, lng: 7.7917 },
    "rheydt": { lat: 51.1667, lng: 6.45 },
    "rhynern": { lat: 51.6299, lng: 7.8581 },
    "ribnitzdamgarten": { lat: 54.25, lng: 12.4667 },
    "richterich": { lat: 50.8086, lng: 6.0625 },
    "riedlingen": { lat: 48.1553, lng: 9.4728 },
    "riegelsberg": { lat: 49.2833, lng: 6.9167 },
    "rielasingenworblingen": { lat: 47.7314, lng: 8.8386 },
    "riesa": { lat: 51.3081, lng: 13.2939 },
    "rietberg": { lat: 51.8, lng: 8.4333 },
    "rimbach": { lat: 49.624, lng: 8.7603 },
    "rinteln": { lat: 52.1906, lng: 9.0814 },
    "ritterhude": { lat: 53.1831, lng: 8.7561 },
    "rodenbach": { lat: 50.1389, lng: 9.0417 },
    "rodental": { lat: 50.2833, lng: 11.0667 },
    "rodgau": { lat: 50.0167, lng: 8.8833 },
    "roding": { lat: 49.2, lng: 12.5167 },
    "rodinghausen": { lat: 52.25, lng: 8.4667 },
    "roetgen": { lat: 50.65, lng: 6.2 },
    "rommerskirchen": { lat: 51.0347, lng: 6.6914 },
    "ronnenberg": { lat: 52.3194, lng: 9.6556 },
    "rosbachvorderhohe": { lat: 50.2986, lng: 8.7006 },
    "rosdorf": { lat: 51.5, lng: 9.9 },
    "rosenheim": { lat: 47.85, lng: 12.1333 },
    "rosrath": { lat: 50.9, lng: 7.1833 },
    "rossdorf": { lat: 49.85, lng: 8.75 },
    "rosstal": { lat: 49.4, lng: 10.8833 },
    "rostock": { lat: 54.0833, lng: 12.1333 },
    "rotenburganderfulda": { lat: 50.9961, lng: 9.7278 },
    "roth": { lat: 49.2461, lng: 11.0911 },
    "rothenbachanderpegnitz": { lat: 49.4847, lng: 11.2475 },
    "rothenburgobdertauber": { lat: 49.3833, lng: 10.1833 },
    "rottenburganderlaaber": { lat: 48.7019, lng: 12.0272 },
    "rottweil": { lat: 48.1681, lng: 8.6247 },
    "rudersberg": { lat: 48.8856, lng: 9.5281 },
    "rudesheimamrhein": { lat: 49.9833, lng: 7.9306 },
    "rudolstadt": { lat: 50.7169, lng: 11.3275 },
    "runkel": { lat: 50.4053, lng: 8.155 },
    "ruppichteroth": { lat: 50.8439, lng: 7.4836 },
    "russelsheim": { lat: 50, lng: 8.4333 },
    "rutesheim": { lat: 48.8097, lng: 8.945 },
    "ruthen": { lat: 51.4933, lng: 8.4833 },
    "saalfeld": { lat: 50.65, lng: 11.3667 },
    "saarbrucken": { lat: 49.2333, lng: 7 },
    "saarlouis": { lat: 49.3167, lng: 6.75 },
    "saarwellingen": { lat: 49.35, lng: 6.8333 },
    "salsitz": { lat: 54.5164, lng: 13.6411 },
    "salzgitter": { lat: 52.15, lng: 10.3333 },
    "salzhemmendorf": { lat: 52.0667, lng: 9.5833 },
    "salzkotten": { lat: 51.6708, lng: 8.6047 },
    "salzwedel": { lat: 52.85, lng: 11.15 },
    "sande": { lat: 53.4833, lng: 8 },
    "sandhausen": { lat: 49.3439, lng: 8.6581 },
    "sangerhausen": { lat: 51.4667, lng: 11.3 },
    "sanktaugustin": { lat: 50.77, lng: 7.1867 },
    "sanktgeorgenimschwarzwald": { lat: 48.1247, lng: 8.3308 },
    "sanktingbert": { lat: 49.3, lng: 7.1167 },
    "sanktleonrot": { lat: 49.2653, lng: 8.5986 },
    "sanktwendel": { lat: 49.4667, lng: 7.1667 },
    "sarstedt": { lat: 52.2394, lng: 9.8606 },
    "sassenberg": { lat: 51.9897, lng: 8.0408 },
    "sassenburg": { lat: 52.5167, lng: 10.6333 },
    "schaafheim": { lat: 49.9167, lng: 9.0167 },
    "schalksmuhle": { lat: 51.2167, lng: 7.5167 },
    "scharbeutz": { lat: 54.0214, lng: 10.7456 },
    "scheessel": { lat: 53.1706, lng: 9.4831 },
    "schenefeld": { lat: 53.6028, lng: 9.8233 },
    "schermbeck": { lat: 51.695, lng: 6.8756 },
    "schierling": { lat: 48.8347, lng: 12.1397 },
    "schiffdorf": { lat: 53.5358, lng: 8.6589 },
    "schifferstadt": { lat: 49.3833, lng: 8.3667 },
    "schiffweiler": { lat: 49.3667, lng: 7.1167 },
    "schkeuditz": { lat: 51.4, lng: 12.2167 },
    "schkopau": { lat: 51.3833, lng: 11.9667 },
    "schlangen": { lat: 51.8167, lng: 8.8331 },
    "schleiden": { lat: 50.5331, lng: 6.4667 },
    "schleiz": { lat: 50.5833, lng: 11.8167 },
    "schleswig": { lat: 54.5186, lng: 9.5653 },
    "schleusingen": { lat: 50.5167, lng: 10.75 },
    "schlitz": { lat: 50.6667, lng: 9.5667 },
    "schlossholtestukenbrock": { lat: 51.8833, lng: 8.6167 },
    "schluchtern": { lat: 50.35, lng: 9.5167 },
    "schmalkalden": { lat: 50.7167, lng: 10.45 },
    "schmallenberg": { lat: 51.149, lng: 8.2845 },
    "schmelz": { lat: 49.4167, lng: 6.8333 },
    "schmolln": { lat: 50.895, lng: 12.3564 },
    "schnaittach": { lat: 49.5592, lng: 11.3431 },
    "schneeberg": { lat: 50.5942, lng: 12.6456 },
    "schneverdingen": { lat: 53.1167, lng: 9.8 },
    "schonaich": { lat: 48.6569, lng: 9.0628 },
    "schonebeck": { lat: 52.0167, lng: 11.75 },
    "schonefeld": { lat: 52.3883, lng: 13.5047 },
    "schongau": { lat: 47.8167, lng: 10.9 },
    "schoningen": { lat: 52.1333, lng: 10.95 },
    "schonwaldesiedlung": { lat: 52.65, lng: 12.9833 },
    "schopfheim": { lat: 47.65, lng: 7.8167 },
    "schorndorf": { lat: 48.8, lng: 9.5333 },
    "schortens": { lat: 53.5333, lng: 7.95 },
    "schotten": { lat: 50.5, lng: 9.1167 },
    "schramberg": { lat: 48.2269, lng: 8.3842 },
    "schriesheim": { lat: 49.4736, lng: 8.6592 },
    "schrobenhausen": { lat: 48.5333, lng: 11.2667 },
    "schulzendorf": { lat: 52.3667, lng: 13.5831 },
    "schuttorf": { lat: 52.3167, lng: 7.2167 },
    "schwabach": { lat: 49.3292, lng: 11.0208 },
    "schwabischgmund": { lat: 48.8, lng: 9.8 },
    "schwabischhall": { lat: 49.1122, lng: 9.7375 },
    "schwabmunchen": { lat: 48.1789, lng: 10.755 },
    "schwaigern": { lat: 49.1333, lng: 9.05 },
    "schwaikheim": { lat: 48.8714, lng: 9.3531 },
    "schwalbach": { lat: 49.2833, lng: 6.8167 },
    "schwalmstadt": { lat: 50.9333, lng: 9.2167 },
    "schwalmtal": { lat: 51.2225, lng: 6.2625 },
    "schwandorf": { lat: 49.3283, lng: 12.11 },
    "schwanewede": { lat: 53.2333, lng: 8.6 },
    "schwarzenbek": { lat: 53.5042, lng: 10.4792 },
    "schwarzenberg": { lat: 50.5453, lng: 12.7792 },
    "schwarzenbruck": { lat: 49.35, lng: 11.2333 },
    "schwedtoder": { lat: 53.05, lng: 14.2667 },
    "schweinfurt": { lat: 50.05, lng: 10.2333 },
    "schwelm": { lat: 51.2667, lng: 7.2667 },
    "schwerin": { lat: 53.6333, lng: 11.4167 },
    "schwerte": { lat: 51.4458, lng: 7.5653 },
    "schwetzingen": { lat: 49.3833, lng: 8.5667 },
    "schwieberdingen": { lat: 48.8778, lng: 9.075 },
    "sebnitz": { lat: 50.9667, lng: 14.2833 },
    "seeheimjugenheim": { lat: 49.75, lng: 8.65 },
    "seelze": { lat: 52.3961, lng: 9.5981 },
    "seesen": { lat: 51.8931, lng: 10.1783 },
    "seevetal": { lat: 53.3833, lng: 9.9667 },
    "sehnde": { lat: 52.3161, lng: 9.9642 },
    "selb": { lat: 50.1667, lng: 12.1333 },
    "seligenstadt": { lat: 50.0333, lng: 8.9667 },
    "selm": { lat: 51.6833, lng: 7.4833 },
    "senden": { lat: 48.3167, lng: 10.0667 },
    "sendenhorst": { lat: 51.8439, lng: 7.8278 },
    "senftenberg": { lat: 51.5167, lng: 14.0167 },
    "siegburg": { lat: 50.8014, lng: 7.2044 },
    "siegen": { lat: 50.8833, lng: 8.0167 },
    "siegsdorf": { lat: 47.8167, lng: 12.65 },
    "sigmaringen": { lat: 48.0869, lng: 9.2167 },
    "simbachaminn": { lat: 48.2667, lng: 13.0167 },
    "simmerath": { lat: 50.6069, lng: 6.3 },
    "sindelfingen": { lat: 48.7133, lng: 9.0028 },
    "singen": { lat: 47.7628, lng: 8.84 },
    "sinsheim": { lat: 49.25, lng: 8.8833 },
    "sinzheim": { lat: 48.7619, lng: 8.1669 },
    "sinzig": { lat: 50.5453, lng: 7.2519 },
    "soest": { lat: 51.5711, lng: 8.1092 },
    "solingen": { lat: 51.1719, lng: 7.0847 },
    "soltau": { lat: 52.9833, lng: 9.8333 },
    "sommerda": { lat: 51.1617, lng: 11.1169 },
    "sondershausen": { lat: 51.3667, lng: 10.8667 },
    "sonneberg": { lat: 50.35, lng: 11.1667 },
    "sonsbeck": { lat: 51.6089, lng: 6.3769 },
    "sonthofen": { lat: 47.5158, lng: 10.2811 },
    "spaichingen": { lat: 48.0758, lng: 8.7378 },
    "spelle": { lat: 52.3667, lng: 7.4667 },
    "spenge": { lat: 52.1333, lng: 8.4833 },
    "speyer": { lat: 49.3194, lng: 8.4311 },
    "spiesenelversberg": { lat: 49.3167, lng: 7.1333 },
    "spremberg": { lat: 51.5717, lng: 14.3794 },
    "springe": { lat: 52.2167, lng: 9.55 },
    "sprockhovel": { lat: 51.3667, lng: 7.25 },
    "stade": { lat: 53.6008, lng: 9.4764 },
    "stadtallendorf": { lat: 50.8333, lng: 9.0167 },
    "stadthagen": { lat: 52.3247, lng: 9.2069 },
    "stadtlohn": { lat: 51.9925, lng: 6.915 },
    "stahnsdorf": { lat: 52.3922, lng: 13.2167 },
    "starnberg": { lat: 47.9972, lng: 11.3406 },
    "stassfurt": { lat: 51.8667, lng: 11.5667 },
    "staufenimbreisgau": { lat: 47.8814, lng: 7.7314 },
    "staufenberg": { lat: 50.6667, lng: 8.7167 },
    "steinbeinurnberg": { lat: 49.4167, lng: 11.0167 },
    "steinauanderstrasse": { lat: 50.3167, lng: 9.4667 },
    "steinbachamtaunus": { lat: 50.1667, lng: 8.5667 },
    "steinen": { lat: 47.6453, lng: 7.7403 },
    "steinfeld": { lat: 52.6, lng: 8.2167 },
    "steinfurt": { lat: 52.1475, lng: 7.3442 },
    "steinhagen": { lat: 52.005, lng: 8.4147 },
    "steinheimamalbuch": { lat: 48.6922, lng: 10.0642 },
    "steinheimamdermurr": { lat: 48.9667, lng: 9.2833 },
    "steinheim": { lat: 51.8658, lng: 9.0944 },
    "stelle": { lat: 53.3667, lng: 10.1167 },
    "stendal": { lat: 52.6, lng: 11.85 },
    "stephanskirchen": { lat: 47.85, lng: 12.1833 },
    "stockach": { lat: 47.8514, lng: 9.0114 },
    "stockelsdorf": { lat: 53.8833, lng: 10.65 },
    "stolberg": { lat: 50.7667, lng: 6.2333 },
    "stollberg": { lat: 50.7083, lng: 12.7783 },
    "straelen": { lat: 51.45, lng: 6.2667 },
    "stralsund": { lat: 54.3092, lng: 13.0819 },
    "straubing": { lat: 48.8833, lng: 12.5667 },
    "strausberg": { lat: 52.5833, lng: 13.8833 },
    "stuhr": { lat: 53.0167, lng: 8.75 },
    "stuttgart": { lat: 48.7775, lng: 9.18 },
    "suchteln": { lat: 51.2833, lng: 6.3833 },
    "sudlohn": { lat: 51.9436, lng: 6.8664 },
    "suhl": { lat: 50.6106, lng: 10.6931 },
    "sulingen": { lat: 52.6667, lng: 8.8 },
    "sulzamneckar": { lat: 48.3628, lng: 8.6317 },
    "sulzbach": { lat: 49.2833, lng: 7.0667 },
    "sulzbachrosenberg": { lat: 49.5, lng: 11.75 },
    "sundern": { lat: 51.3167, lng: 8 },
    "sussen": { lat: 48.6797, lng: 9.7575 },
    "syke": { lat: 52.9131, lng: 8.8269 },
    "tamm": { lat: 48.9167, lng: 9.1167 },
    "tangerhutte": { lat: 52.4333, lng: 11.8 },
    "tangermunde": { lat: 52.5408, lng: 11.9689 },
    "tauberbischofsheim": { lat: 49.6225, lng: 9.6628 },
    "taucha": { lat: 51.38, lng: 12.4936 },
    "taufkirchen": { lat: 48.05, lng: 11.6167 },
    "taunusstein": { lat: 50.1333, lng: 8.15 },
    "tecklenburg": { lat: 52.2194, lng: 7.8125 },
    "teisendorf": { lat: 47.85, lng: 12.8167 },
    "telgte": { lat: 51.9819, lng: 7.7856 },
    "teltow": { lat: 52.4022, lng: 13.2706 },
    "templin": { lat: 53.1167, lng: 13.5 },
    "teningen": { lat: 48.1269, lng: 7.8103 },
    "tettnang": { lat: 47.6708, lng: 9.5875 },
    "thale": { lat: 51.75, lng: 11.05 },
    "tholey": { lat: 49.4667, lng: 7.0333 },
    "timmendorferstrand": { lat: 53.9944, lng: 10.7825 },
    "tirschenreuth": { lat: 49.8833, lng: 12.3333 },
    "titiseeneustadt": { lat: 47.9122, lng: 8.2147 },
    "titz": { lat: 51.0061, lng: 6.4242 },
    "togingaminn": { lat: 48.25, lng: 12.5667 },
    "tonisvorst": { lat: 51.3208, lng: 6.4931 },
    "torgau": { lat: 51.5603, lng: 13.0056 },
    "torgelow": { lat: 53.6167, lng: 14 },
    "tornesch": { lat: 53.7, lng: 9.7167 },
    "tostedt": { lat: 53.2833, lng: 9.7167 },
    "traunreut": { lat: 47.9667, lng: 12.5833 },
    "traunstein": { lat: 47.8667, lng: 12.6333 },
    "trebbin": { lat: 52.2167, lng: 13.2 },
    "trebur": { lat: 49.925, lng: 8.4056 },
    "treuchtlingen": { lat: 48.9553, lng: 10.9094 },
    "trier": { lat: 49.7567, lng: 6.6414 },
    "trittau": { lat: 53.6167, lng: 10.4 },
    "troisdorf": { lat: 50.8161, lng: 7.1556 },
    "trossingen": { lat: 48.0756, lng: 8.6361 },
    "trostberganderalz": { lat: 48.0167, lng: 12.55 },
    "tubingen": { lat: 48.52, lng: 9.0556 },
    "tuttlingen": { lat: 47.985, lng: 8.8233 },
    "tutzing": { lat: 47.9089, lng: 11.2814 },
    "twist": { lat: 52.6167, lng: 7.0333 },
    "twistringen": { lat: 52.8, lng: 8.65 },
    "ubachpalenberg": { lat: 50.9197, lng: 6.1194 },
    "uberherrn": { lat: 49.25, lng: 6.7 },
    "uberlingen": { lat: 47.7667, lng: 9.165 },
    "ubstadtweiher": { lat: 49.1656, lng: 8.625 },
    "ueckermunde": { lat: 53.7389, lng: 14.0444 },
    "uelzen": { lat: 52.9647, lng: 10.5658 },
    "uetersen": { lat: 53.6872, lng: 9.6692 },
    "uetze": { lat: 52.4661, lng: 10.2039 },
    "uhingen": { lat: 48.7058, lng: 9.5919 },
    "ulm": { lat: 48.4, lng: 9.9833 },
    "unna": { lat: 51.5347, lng: 7.6889 },
    "unterfohring": { lat: 48.2, lng: 11.65 },
    "untergruppenbach": { lat: 49.0833, lng: 9.2667 },
    "unterhaching": { lat: 48.0658, lng: 11.61 },
    "urbach": { lat: 48.8133, lng: 9.5789 },
    "usingen": { lat: 50.3344, lng: 8.5375 },
    "uslar": { lat: 51.6597, lng: 9.6358 },
    "vaihingenanderenz": { lat: 48.9328, lng: 8.9564 },
    "vallendar": { lat: 50.3971, lng: 7.622 },
    "varel": { lat: 53.3969, lng: 8.1361 },
    "vaterstetten": { lat: 48.105, lng: 11.7706 },
    "vechelde": { lat: 52.2608, lng: 10.372 },
    "vechta": { lat: 52.7306, lng: 8.2886 },
    "veitshochheim": { lat: 49.8328, lng: 9.8817 },
    "velbert": { lat: 51.3333, lng: 7.05 },
    "velen": { lat: 51.8939, lng: 6.9897 },
    "vellmar": { lat: 51.35, lng: 9.4667 },
    "velten": { lat: 52.6833, lng: 13.1833 },
    "verden": { lat: 52.9233, lng: 9.235 },
    "verl": { lat: 51.8831, lng: 8.5167 },
    "versmold": { lat: 52.0436, lng: 8.15 },
    "vettweiss": { lat: 50.7389, lng: 6.5972 },
    "viechtach": { lat: 49.0792, lng: 12.8847 },
    "viernheim": { lat: 49.5417, lng: 8.5786 },
    "viersen": { lat: 51.2561, lng: 6.3972 },
    "villingenschwenningen": { lat: 48.0603, lng: 8.4586 },
    "vilsbiburg": { lat: 48.45, lng: 12.35 },
    "visbek": { lat: 52.8366, lng: 8.3098 },
    "visselhovede": { lat: 52.9667, lng: 9.5833 },
    "vlotho": { lat: 52.1667, lng: 8.8497 },
    "voerde": { lat: 51.6, lng: 6.6833 },
    "vohburganderdonau": { lat: 48.7667, lng: 11.6167 },
    "vohringen": { lat: 48.2833, lng: 10.0833 },
    "volkach": { lat: 49.8667, lng: 10.2167 },
    "volklingen": { lat: 49.25, lng: 6.8333 },
    "vreden": { lat: 52.0333, lng: 6.8333 },
    "wachtberg": { lat: 50.6167, lng: 7.1333 },
    "wachtersbach": { lat: 50.2547, lng: 9.2919 },
    "wadern": { lat: 49.5167, lng: 6.8667 },
    "wadersloh": { lat: 51.7386, lng: 8.2514 },
    "wadgassen": { lat: 49.2667, lng: 6.7667 },
    "waghausel": { lat: 49.25, lng: 8.5167 },
    "wahlstedt": { lat: 53.95, lng: 10.2167 },
    "waiblingen": { lat: 48.8303, lng: 9.3169 },
    "waldmichelbach": { lat: 49.5667, lng: 8.8333 },
    "waldbrol": { lat: 50.8789, lng: 7.615 },
    "waldenbuch": { lat: 48.6372, lng: 9.1317 },
    "waldfeucht": { lat: 51.0714, lng: 5.9831 },
    "waldheim": { lat: 51.0667, lng: 13.0167 },
    "waldkirch": { lat: 48.1, lng: 7.9667 },
    "waldkirchen": { lat: 48.7305, lng: 13.6011 },
    "waldkraiburg": { lat: 48.2167, lng: 12.4 },
    "waldniel": { lat: 51.2131, lng: 6.2731 },
    "waldshuttiengen": { lat: 47.6231, lng: 8.2144 },
    "walldorf": { lat: 49.3, lng: 8.65 },
    "walldurn": { lat: 49.5831, lng: 9.3681 },
    "wallenhorst": { lat: 52.35, lng: 8.0167 },
    "wallerfangen": { lat: 49.3128, lng: 6.735 },
    "walsrode": { lat: 52.8667, lng: 9.5833 },
    "waltenhofen": { lat: 47.6667, lng: 10.3 },
    "waltershausen": { lat: 50.8975, lng: 10.5558 },
    "waltrop": { lat: 51.6167, lng: 7.3833 },
    "wandlitz": { lat: 52.75, lng: 13.4497 },
    "wangenimallgau": { lat: 47.6858, lng: 9.8342 },
    "wanzleben": { lat: 52.0667, lng: 11.4333 },
    "warburg": { lat: 51.5, lng: 9.1697 },
    "wardenburg": { lat: 53.0617, lng: 8.1967 },
    "waren": { lat: 53.5167, lng: 12.6833 },
    "warendorf": { lat: 51.9539, lng: 7.9933 },
    "warstein": { lat: 51.45, lng: 8.35 },
    "wassenberg": { lat: 51.1, lng: 6.15 },
    "wasserburgaminn": { lat: 48.0617, lng: 12.2333 },
    "wedel": { lat: 53.5833, lng: 9.7 },
    "weener": { lat: 53.1692, lng: 7.3564 },
    "weeze": { lat: 51.6267, lng: 6.1967 },
    "wegberg": { lat: 51.1417, lng: 6.2792 },
    "wehr": { lat: 47.6297, lng: 7.9044 },
    "wehrheim": { lat: 50.3, lng: 8.5667 },
    "weilamrhein": { lat: 47.5947, lng: 7.6108 },
    "weilderstadt": { lat: 48.7508, lng: 8.8706 },
    "weilimschonbuch": { lat: 48.6214, lng: 9.0611 },
    "weilburg": { lat: 50.4833, lng: 8.25 },
    "weilerswist": { lat: 50.7667, lng: 6.8331 },
    "weilheimanderteck": { lat: 48.615, lng: 9.5386 },
    "weilheim": { lat: 47.8333, lng: 11.15 },
    "weilmunster": { lat: 50.4333, lng: 8.3667 },
    "weimar": { lat: 50.9811, lng: 11.3294 },
    "weinbohla": { lat: 51.1667, lng: 13.5667 },
    "weingarten": { lat: 47.8092, lng: 9.6444 },
    "weinheim": { lat: 49.55, lng: 8.6667 },
    "weinsberg": { lat: 49.1518, lng: 9.2857 },
    "weissenburg": { lat: 49.0306, lng: 10.9719 },
    "weissenfels": { lat: 51.2, lng: 11.9667 },
    "weissenhorn": { lat: 48.3, lng: 10.1667 },
    "weissenthurm": { lat: 50.4144, lng: 7.4606 },
    "weisswasseroberlausitz": { lat: 51.5, lng: 14.6333 },
    "weiterstadt": { lat: 49.9, lng: 8.6 },
    "welver": { lat: 51.6167, lng: 7.9583 },
    "welzheim": { lat: 48.8747, lng: 9.6344 },
    "wendeburg": { lat: 52.3167, lng: 10.4 },
    "wendelstein": { lat: 49.3536, lng: 11.1483 },
    "wenden": { lat: 50.9667, lng: 7.8667 },
    "wendlingenamneckar": { lat: 48.6747, lng: 9.3817 },
    "wennigsen": { lat: 52.2742, lng: 9.5708 },
    "wentorfbeihamburg": { lat: 53.4931, lng: 10.2533 },
    "wenzenbach": { lat: 49.0747, lng: 12.1944 },
    "werdau": { lat: 50.7333, lng: 12.3833 },
    "werdohl": { lat: 51.2667, lng: 7.7667 },
    "werl": { lat: 51.55, lng: 7.92 },
    "werlte": { lat: 52.85, lng: 7.6833 },
    "wermelskirchen": { lat: 51.15, lng: 7.2167 },
    "wernau": { lat: 48.6886, lng: 9.4222 },
    "werneck": { lat: 49.9833, lng: 10.1 },
    "werneuchen": { lat: 52.6333, lng: 13.7333 },
    "wernigerode": { lat: 51.835, lng: 10.7853 },
    "wertheim": { lat: 49.7589, lng: 9.5175 },
    "werther": { lat: 52.075, lng: 8.4125 },
    "wertingen": { lat: 48.5333, lng: 10.6667 },
    "werve": { lat: 51.6667, lng: 7.6167 },
    "wesel": { lat: 51.6586, lng: 6.6178 },
    "wesseling": { lat: 50.8167, lng: 6.9667 },
    "westerkappeln": { lat: 52.3806, lng: 7.6 },
    "westerland": { lat: 54.91, lng: 8.3075 },
    "westerstede": { lat: 53.25, lng: 7.9167 },
    "wetterruhr": { lat: 51.3881, lng: 7.395 },
    "wetter": { lat: 50.8833, lng: 8.7167 },
    "wetterzeube": { lat: 51.8333, lng: 12.2333 },
    "wetzlar": { lat: 50.5667, lng: 8.5 },
    "wickede": { lat: 51.4964, lng: 7.8658 },
    "wiefelstede": { lat: 53.2581, lng: 8.1172 },
    "wiehl": { lat: 50.95, lng: 7.5333 },
    "wiesbaden": { lat: 50.0825, lng: 8.24 },
    "wiesloch": { lat: 49.2942, lng: 8.6983 },
    "wiesmoor": { lat: 53.416, lng: 7.7337 },
    "wietmarschen": { lat: 52.5333, lng: 7.1333 },
    "wietze": { lat: 52.65, lng: 9.8333 },
    "wildau": { lat: 52.3167, lng: 13.6333 },
    "wildberg": { lat: 48.6239, lng: 8.7472 },
    "wildeshausen": { lat: 52.9, lng: 8.4333 },
    "wilhelmshaven": { lat: 53.5286, lng: 8.1056 },
    "wilkauhasslau": { lat: 50.6667, lng: 12.5167 },
    "willich": { lat: 51.2631, lng: 6.5492 },
    "willstatt": { lat: 48.5417, lng: 7.8964 },
    "wilnsdorf": { lat: 50.8167, lng: 8.1 },
    "wilsdruff": { lat: 51.0522, lng: 13.5383 },
    "winnenden": { lat: 48.8764, lng: 9.3978 },
    "winsen": { lat: 53.3667, lng: 10.2167 },
    "winterberg": { lat: 51.2, lng: 8.5167 },
    "wipperfurth": { lat: 51.1167, lng: 7.4 },
    "wismar": { lat: 53.9, lng: 11.4667 },
    "wissen": { lat: 50.7825, lng: 7.735 },
    "witten": { lat: 51.4333, lng: 7.3333 },
    "wittenberge": { lat: 53, lng: 11.75 },
    "wittingen": { lat: 52.7167, lng: 10.7333 },
    "wittlich": { lat: 49.9869, lng: 6.8897 },
    "wittmund": { lat: 53.575, lng: 7.7808 },
    "wittstock": { lat: 53.1636, lng: 12.4856 },
    "witzenhausen": { lat: 51.3422, lng: 9.8578 },
    "wolfenbuttel": { lat: 52.1622, lng: 10.5369 },
    "wolfersheim": { lat: 50.3975, lng: 8.8114 },
    "wolfhagen": { lat: 51.3167, lng: 9.1667 },
    "wolfratshausen": { lat: 47.9133, lng: 11.4278 },
    "wolfsburg": { lat: 52.4231, lng: 10.7872 },
    "wolgast": { lat: 54.05, lng: 13.7667 },
    "wolmirstedt": { lat: 52.2519, lng: 11.6297 },
    "wolnzach": { lat: 48.6, lng: 11.6167 },
    "worms": { lat: 49.6319, lng: 8.3653 },
    "worpswede": { lat: 53.2222, lng: 8.9278 },
    "worrstadt": { lat: 49.8431, lng: 8.1156 },
    "worthamrhein": { lat: 49.0517, lng: 8.2603 },
    "wulfrath": { lat: 51.2833, lng: 7.0333 },
    "wunsiedel": { lat: 50.0167, lng: 12.0167 },
    "wunstorf": { lat: 52.4275, lng: 9.4294 },
    "wuppertal": { lat: 51.2667, lng: 7.1833 },
    "wurselen": { lat: 50.8167, lng: 6.1333 },
    "wurzburg": { lat: 49.7833, lng: 9.9333 },
    "wurzen": { lat: 51.3667, lng: 12.7167 },
    "wustermark": { lat: 52.55, lng: 12.95 },
    "xanten": { lat: 51.6622, lng: 6.4539 },
    "zehdenick": { lat: 52.9833, lng: 13.3333 },
    "zeitz": { lat: 51.0478, lng: 12.1383 },
    "zellamehlis": { lat: 50.6597, lng: 10.6669 },
    "zerbst": { lat: 51.9681, lng: 12.0844 },
    "zetel": { lat: 53.4197, lng: 7.9742 },
    "zeulenroda": { lat: 50.6486, lng: 11.9806 },
    "zeuthen": { lat: 52.35, lng: 13.6281 },
    "zeven": { lat: 53.3, lng: 9.2833 },
    "zirndorf": { lat: 49.45, lng: 10.95 },
    "zittau": { lat: 50.8961, lng: 14.8072 },
    "zorbig": { lat: 51.6167, lng: 12.1167 },
    "zorneding": { lat: 48.0833, lng: 11.8333 },
    "zossen": { lat: 52.2167, lng: 13.4497 },
    "zschopau": { lat: 50.75, lng: 13.0667 },
    "zulpich": { lat: 50.7, lng: 6.65 },
    "zweibrucken": { lat: 49.25, lng: 7.3667 },
    "zwenkau": { lat: 51.2175, lng: 12.3242 },
    "zwickau": { lat: 50.7167, lng: 12.5 },
    "zwiesel": { lat: 49.0167, lng: 13.2333 },
    "zwonitz": { lat: 50.6167, lng: 12.8 }, };
export default listOfCitiesWithLatLng;
